import { configService } from './config';
import { brandService } from './brand';

// 支持的语言类型
export type LanguageType = 'zh' | 'zh-TW' | 'en';

// 语言文本映射
const translations: Record<LanguageType, Record<string, string>> = {
  zh: {
    // Sequence Detect
    manageContacts: '管理联系人',
    alertContacts: '跟急联系人',
    alertContactsTitle: '跟急联系人',
    alertContactsDesc: '管理将接收行为跟急的联系人',

    // 通用
    save: '保存',
    cancel: '取消',
    saving: '保存中...',
    create: '创建',
    delete: '删除',
    optional: '可选',
    user: '用户',
    login: '登录',
    inDevelopment: '正在开发中',
    
    // 设置
    settings: '设置',
    general: '通用',
    model: '模型',
    shortcuts: '快捷键',
    about: '关于',
    aboutVersion: '版本',
    aboutContactEmail: '联系邮箱',
    aboutUserManual: '用户手册',
    aboutServiceTerms: '服务条款',
    aboutExportLogs: '导出日志',
    aboutExportingLogs: '导出中...',
    aboutExportLogsFailed: '导出日志失败',
    aboutExportLogsSuccess: '日志导出成功',
    aboutExportLogsPartial: '日志导出成功（缺失日志已按空文件补齐）',
    testMode: '测试模式',
    theme: '主题',
    appearance: '外观',
    language: '语言',
    light: '浅色',
    dark: '深色',
    system: '跟随系统',
    chinese: '中文',
    traditionalChinese: '繁體中文',
    english: 'English',
    
    // API设置
    apiKey: 'API Key',
    apiKeyPlaceholder: '输入你的 API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: '输入 API 基础 URL',
    baseUrlHint1: '一般只需填写域名，系统自动补全路径',
    baseUrlHintExample1: 'https://api.siliconflow.cn',
    baseUrlHint2: '非标准路径可填写完整地址',
    baseUrlHintExample2: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
    currentModel: '当前模型',
    availableModels: '可用模型列表',
    modelSwitchHint: '在聊天界面可以切换使用的模型',
    
    // 模型提供商设置
    enabled: '已启用',
    disabled: '已禁用',
    providerStatusOn: '已开启',
    providerStatusOff: '未开启',
    providerSettings: '提供商设置',
    modelProviders: '模型提供商',
    projectConnections: '项目连接',
    integrationProjects: '连接项目',
    integrationAddProject: '添加',
    integrationNewProject: '新项目连接',
    integrationDescription: '连接任何提供 OpenAPI 3.x 文档的项目，并管理可供 AI 使用的接口。',
    integrationProjectName: '项目名称',
    integrationAuthType: '认证方式',
    integrationAuthNone: '无需认证',
    integrationHeaderName: 'API Key 请求头',
    integrationSecretUnchanged: '已配置；留空则保持不变',
    integrationDiscover: '识别 API',
    integrationApiDirectory: 'API 接口目录',
    integrationOperations: '个接口',
    integrationNoProjects: '尚未添加项目连接',
    integrationNoEndpoints: '尚未识别到接口，请先保存并识别 OpenAPI。',
    integrationNameRequired: '请填写项目名称',
    integrationBaseUrlRequired: '请填写 API Base URL',
    integrationSaved: '项目连接已保存',
    integrationSaveFailed: '保存项目连接失败',
    integrationLoadFailed: '加载项目连接失败',
    integrationTestFailed: '连接测试失败',
    integrationDiscoverySuccess: '成功识别',
    integrationDiscoveryFailed: '识别 OpenAPI 失败',
    integrationDeleteConfirm: '确定删除此项目连接及其 API 配置吗？',
    integrationDeleteFailed: '删除项目连接失败',
    integrationEndpointUpdateFailed: '更新接口权限失败',
    integrationPolicyDisabled: '禁用',
    integrationPolicyManual: '仅手动调用',
    integrationPolicyAgentRead: '允许 AI 读取',
    integrationPolicyAgentWrite: '允许 AI 写入',
    integrationPolicyAutomatic: '允许主动介入',
    integrationConnectionEnabled: '连接已启用',
    integrationConnectionDisabled: '连接已禁用',
    integrationAiToolsAuthorized: '个 AI 工具已授权',
    integrationNoAiTools: '尚未授权任何接口给 AI',
    integrationAiAuthorizationHint: 'API Key 只负责连接认证；接口还需要授权后才会成为 AI 工具。写入接口请在下方逐个授权。',
    integrationAuthorizeAllReads: '授权全部 GET',
    integrationAuthorizing: '授权中...',
    integrationReadAuthorizationSuccess: '已授权读取接口',
    integrationReadAuthorizationFailed: '批量授权读取接口失败',
    demoIntegrationWarning: '⚠️ 演示模式：请勿连接正在使用中的真实 API。此功能仅供演示和探索，连接的 API Key 和配置可能被他人查看。',
    addModel: '添加模型',
    editModel: '编辑模型',
    addNewModel: '添加新模型',
    modelName: '模型名称',
    modelId: '模型ID',
    modelNameAndIdRequired: '请填写模型名称和模型ID',
    modelIdExists: '模型ID已存在，请使用不同的ID',
    ollamaModelName: '模型名称',
    ollamaModelNameHint: '输入 Ollama 中已安装的模型名称，如 qwen3:8b、lfm2:latest',
    ollamaModelNamePlaceholder: 'qwen3:8b',
    ollamaDisplayName: '显示名称（可选）',
    ollamaDisplayNameHint: '自定义在列表中显示的名称，留空则使用模型名称',
    ollamaDisplayNamePlaceholder: '我的 Qwen3 模型',
    ollamaModelNameRequired: '请填写模型名称',
    supportsImageInput: '支持图像输入',
    imageInput: '图像',
    noModelsAvailable: '暂无可用模型',
    addFirstModel: '添加第一个模型',
    testConnection: '测试连接',
    connectionTestResult: '连接测试结果',
    testing: '测试中...',
    connectionSuccess: '连接成功',
    connectionFailed: '连接失败',
    noModelsConfigured: '请先添加模型',
    apiFormat: 'API 格式',
    apiFormatNative: 'Anthropic 兼容',
    apiFormatOpenAI: 'OpenAI 兼容',
    apiFormatHint: '请选择 API 协议兼容格式：Anthropic 兼容或 OpenAI 兼容',
    zhipuCodingPlanHint: '启用后使用 GLM Coding Plan 专属 API 端点',
    zhipuCodingPlanEndpointHint: '使用 GLM Coding Plan 时，系统将自动切换到 Coding 专属端点',
    qwenCodingPlanHint: '启用后使用阿里云百炼 Coding Plan 专属 API 端点',
    qwenCodingPlanEndpointHint: '使用 Coding Plan 时，需要配置专属的 API Key（格式：sk-sp-xxxxx）',
    volcengineCodingPlanHint: '启用后使用火山引擎 Coding Plan 专属 API 端点',
    volcengineCodingPlanEndpointHint: '使用 Coding Plan 时，系统将自动切换到 Coding 专属端点',
    moonshotCodingPlanHint: '启用后使用 Moonshot Coding Plan 专属 API 端点',
    moonshotCodingPlanEndpointHint: '使用 Coding Plan 时，系统将自动切换到 Coding 专属端点',
    import: '导入',
    export: '导出',
    importProvidersFailed: '导入失败',
    exportProvidersFailed: '导出失败',
    invalidProvidersFile: '导入文件格式不正确',
    decryptProvidersFailed: '密钥解密失败，请确认文件由当前设备导出',
    decryptProvidersPartial: '部分密钥无法解密，已保留本地密钥或留空，请手动检查',

    // 密码相关
    password: '密码',
    confirmPassword: '确认密码',
    enterPassword: '请输入密码',
    enterPasswordAgain: '请再次输入密码',
    exportPasswordTitle: '设置导出密码',
    importPasswordTitle: '输入导入密码',
    exportPasswordHint: '此密码用于加密你的 API 密钥，导入时需要使用相同的密码',
    importPasswordHint: '请输入导出时设置的密码',
    passwordRequired: '请输入密码',
    passwordMismatch: '两次输入的密码不一致',
    passwordTooShort: '密码长度至少为4位',
    wrongPassword: '密码错误，请检查后重试',
    
    // 快捷键
    keyboardShortcuts: '键盘快捷键',
    newChat: '新建任务',
    search: '搜索任务',
    openSettings: '打开设置',
    close: '关闭',
    loginNotAvailable: '登录功能暂未开放',
    collapse: '收起',
    expand: '展开',
    featureInDevelopment: '正在开发中',
    
    // 错误信息
    failedToLoadSettings: '加载设置失败',
    failedToSaveSettings: '保存设置失败',
    
    // 加载状态
    loading: '加载中...',
    
    // 侧边栏
    conversations: '对话',
    noConversations: '暂无对话',
    createNewChat: '新建对话',
    deleteConversation: '删除对话',
    renameConversation: '重命名',
    moveToProject: '移至项目',
    pinConversation: '置顶聊天',
    unpinConversation: '取消置顶',
    noProject: '无项目',
    noProjects: '暂无项目',
    confirmDelete: '确认删除',
    sequenceDetect: '序列检测',
    confirmDeleteMessage: '确定要删除这个对话吗？此操作不可撤销。',
    searchChats: '搜索聊天',
    searchConversations: '搜索任务...',
    searchNoResults: '未找到匹配任务',
    projects: '项目',
    yourChats: '你的聊天',
    createProject: '新项目',
    projectNamePlaceholder: '项目名称',
    projectColorLabel: '颜色',
    projectIconLabel: '图标',
    project: '项目',
    projectHistory: '历史记录',
    projectPrompt: '提示词',
    projectPromptPlaceholder: '为该项目设置提示词',
    projectSettings: '项目设置',
    projectNameLabel: '项目名称',
    deleteProject: '删除项目',
    confirmDeleteProject: '确定要删除这个项目吗？项目内聊天将移回到聊天列表。此操作不可撤销。',
    folderIconDefault: '默认',
    folderIconHealth: '健康',
    folderIconStudy: '学习',
    folderIconMath: '数学',
    folderIconWork: '工作',
    folderIconCode: '代码',
    folderIconIdea: '灵感',
    
    // 聊天窗口
    sendMessage: '发送消息',
    typeMessage: '询问任何问题...',
    quickPrompt: '询问任何问题',
    regenerateResponse: '重新生成回复',
    copyToClipboard: '复制到剪贴板',
    messageCopied: '消息已复制',
    clearConversation: '清空对话',
    confirmClearConversation: '确定要清空当前对话吗？此操作不可撤销。',
    today: '今天',
    yesterday: '昨天',
    daysAgo: '天前',
    justNow: '刚刚',
    minutesAgo: '分钟前',
    hoursAgo: '小时前',
    welcomeMessage: '我能帮你做什么呢？',
    thinking: '思考中...',
    reasoning: '思考过程',
    editMessage: '编辑消息',
    emptyMessage: '空消息',
    artifactOpen: '打开',
    artifactView: '查看',
    artifactViewing: '预览中',
    artifactPreview: '预览',
    artifactCode: '代码',
    imageLimitReached: '最多上传 10 张图片',
    imageReadError: '读取图片失败',
    imageInputNotSupported: '当前模型不支持图像输入',
    
    // 模型选择
    selectModel: '选择模型',
    
    // 错误提示
    errorOccurred: '发生错误',
    tryAgain: '请重试',
    networkError: '网络错误',
    apiKeyRequired: '需要设置API密钥',
    configureApiKey: '请在设置中配置您的API密钥',
    
    // 初始化
    initializationError: '初始化应用程序失败。请检查您的配置。',
    apiKeyNotConfigured: 'API密钥未配置。请在设置中设置您的API密钥。',

    // MednnectAI
    cowork: '{appName}',
    coworkSandbox: '沙箱',
    coworkSettings: 'MednnectAI 设置',
    coworkHistory: '任务记录',
    coworkNoSessions: '暂无任务记录',
    coworkPinSession: '置顶任务',
    coworkUnpinSession: '取消置顶',
    coworkSessionActions: '更多操作',
    coworkPlaceholder: '分配一个任务或提问任何问题',
    coworkWorkingDirectory: '工作目录',
    coworkWorkingDirectoryPlaceholder: '输入项目路径',
    coworkWorkingDirectoryHint: 'MednnectAI 将在此目录下执行命令',
    coworkSystemPrompt: '系统提示词',
    coworkSystemPromptPlaceholder: '为 MednnectAI 设置自定义指令...',
    coworkSystemPromptHint: '可选的系统提示词，用于自定义 MednnectAI 的行为',
    coworkModelSettingsRequired: '请先在模型设置中配置可用模型与 API Key。',
    coworkModelSettingsTitle: '模型设置',
    coworkModelSettingsHint: 'MednnectAI 使用模型设置中的当前模型与提供商配置。',
    coworkModelSettingsAction: '前往模型设置',
    coworkApiConfigTitle: 'API 配置',
    coworkApiConfigHint: '支持 Anthropic 兼容与 OpenAI 兼容协议（OpenAI 兼容通过本地转换服务接入）。',
    coworkExecutionMode: '执行模式',
    coworkExecutionModeAuto: '自动（优先沙箱）',
    coworkExecutionModeLocal: '本地运行',
    coworkExecutionModeSandbox: '仅沙箱（内置 VM）',
    coworkExecutionModeAutoHint: '优先使用内置 VM 沙箱，不可用时回退本地',
    coworkExecutionModeLocalHint: '始终在本机运行',
    coworkExecutionModeSandboxHint: '要求内置 VM 沙箱可用，否则报错',
    coworkMemoryTitle: '记忆',
    coworkMemoryEnabled: '启用用户记忆',
    coworkMemoryEnabledHint: '将稳定事实注入到系统提示词中的 <userMemories> 区块。',
    coworkMemorySimpleHint: '建议开启后直接使用下方“记忆条目管理”，无需额外配置。',
    coworkMemoryLlmJudgeEnabled: '启用 LLM 二级判定',
    coworkMemoryLlmJudgeEnabledHint: '仅对规则边界样本调用模型复核，提升准确率（会增加少量 API 调用）。',
    coworkMemoryAutoWrite: '自动写入记忆',
    coworkMemoryCaptureEachTurn: '启用隐式更新',
    coworkMemoryGuardLevel: '写入门槛',
    coworkMemoryGuardStrict: '严格',
    coworkMemoryGuardStandard: '标准',
    coworkMemoryGuardRelaxed: '宽松',
    coworkMemoryMaxResults: '注入条目上限',
    coworkMemoryMaxResultsHint: '可选范围 1-60，建议 12',
    coworkMemoryMinScore: '最小相关性阈值',
    coworkMemoryMaxInjectChars: '最大注入字符数',
    coworkMemoryRecallInterval: '自动回忆间隔（轮）',
    coworkMemoryRecallIntervalHint: '每 N 轮自动注入一次记忆，建议 3',
    coworkMemoryCrudTitle: '记忆条目管理',
    coworkMemoryManageHint: '你可以在这里查看、搜索、新增、编辑或删除记忆内容。',
    coworkMemoryTotalLabel: '记忆总数',
    coworkMemoryActiveLabel: '生效中',
    coworkMemoryInactiveLabel: '暂不使用',
    coworkMemoryStatusActive: '生效中',
    coworkMemoryStatusInactive: '暂不使用',
    coworkMemoryStatusDeleted: '已删除',
    coworkMemoryUpdatedAt: '最后更新',
    coworkMemoryEditingTag: '正在编辑当前记忆',
    coworkMemoryRebuildIndex: '重建索引',
    coworkMemoryRebuildSuccess: '记忆索引重建完成',
    coworkMemoryRebuildFailed: '记忆索引重建失败',
    coworkMemoryStatsSummary: '已管理条目数',
    coworkMemorySearchPlaceholder: '搜索记忆内容/来源',
    coworkMemoryCategoryAll: '全部分类',
    coworkMemoryEmpty: '暂无记忆条目',
    coworkMemoryCrudTextPlaceholder: '输入要保存的记忆内容',
    coworkMemoryCrudCreate: '新增条目',
    coworkMemoryCrudUpdate: '更新条目',
    coworkMemoryCrudSaveFailed: '保存记忆条目失败',
    coworkMemoryCrudDeleteFailed: '删除记忆条目失败',
    coworkMemoryAdvancedShow: '显示高级设置',
    coworkMemoryAdvancedHide: '隐藏高级设置',
    coworkMemoryEmbeddingEnabled: '启用本地 embedding 重排',
    coworkMemoryEmbeddingEnabledHint: '在词法检索基础上用本地向量相似度重排结果，提升召回质量',
    coworkMemoryEmbeddingModel: 'Embedding 模型',
    coworkMemoryEmbeddingModelHint: '推荐 BAAI/bge-m3；可改为你已下载的其他 sentence-transformers 模型',
    coworkMemoryEmbeddingLocalModelPath: '本地模型目录（可选）',
    coworkMemoryEmbeddingLocalModelPathHint: '填写后优先加载本地目录；留空时按模型名加载',
    coworkMemoryEmbeddingAutoDownload: '允许自动下载模型',
    coworkMemoryEmbeddingAutoDownloadHint: '关闭后必须提供本地模型目录',
    coworkMemoryEmbeddingDownload: '下载 / 校验模型',
    coworkMemoryEmbeddingDownloading: '下载中...',
    coworkMemoryEmbeddingDownloadHint: '手动触发模型下载（或校验本地模型目录），下载过程可能较慢，请等待进度完成',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding 模型已就绪',
    coworkMemoryEmbeddingDownloadFailed: 'Embedding 模型下载失败',
    coworkMemoryEmbeddingProgressPreparing: '准备下载任务',
    coworkMemoryEmbeddingProgressInit: '初始化环境',
    coworkMemoryEmbeddingProgressDownload: '下载模型文件',
    coworkMemoryEmbeddingProgressLoad: '加载模型',
    coworkMemoryEmbeddingProgressEncode: '模型预热',
    coworkMemoryEmbeddingProgressDone: '完成',
    coworkMemoryEmbeddingProgressError: '失败',
    coworkMemoryEmbeddingWeight: '语义重排权重',
    coworkMemoryEmbeddingWeightHint: '范围 0-1，值越大越依赖 embedding 相似度，建议 0.62',
    coworkSandboxManualInstallNotice: '当前未运行在沙箱模式。若需使用沙箱，请先手动安装沙箱组件。',
    coworkSandboxManualInstallAction: '前往沙箱设置',
    coworkSandboxChecking: '正在检测内置 VM 沙箱...',
    coworkSandboxUnsupported: '当前系统不支持内置 VM 沙箱',
    coworkSandboxRuntimeMissing: '未检测到 VM 运行时',
    coworkSandboxImageMissing: '未检测到沙箱镜像',
    coworkSandboxDownloading: '正在下载沙箱组件...',
    coworkSandboxInstall: '安装沙箱',
    coworkSandboxInstalling: '正在安装...',
    coworkSandboxSelectionBlocked: '当前不可用，请选择自动或本地模式。',
    coworkSandboxBadge: '沙箱',
    coworkLocalBadge: '本地',
    coworkApiProviderModel: '从模型设置选择',
    coworkApiProviderModelCustom: '自定义',
    coworkApiProviderModelHint: '仅显示已启用且已配置 API Key/地址的模型',
    coworkApiBaseUrl: 'API 基础地址',
    coworkApiKey: 'API Key',
    coworkApiModel: '模型名称',
    coworkApiKeyRequired: '需要填写 API Key',
    coworkApiBaseUrlRequired: '需要填写 API 地址',
    coworkApiModelRequired: '需要填写模型名称',
    coworkApiBaseUrlInvalid: 'API 地址格式无效',
    coworkApiConfigSaveFailed: '保存 API 配置失败',
    coworkApiConfigLoadFailed: '加载 API 配置失败',
    coworkStatusIdle: '已停止',
    coworkStatusRunning: '运行中',
    coworkStatusCompleted: '已完成',
    coworkStatusError: '错误',
    coworkPermissionRequired: '需要权限确认',
    coworkPermissionDescription: 'MednnectAI 请求执行以下操作',
    coworkToolName: '工具名称',
    coworkToolInput: '工具参数',
    coworkToolResult: '执行结果',
    coworkToolRunning: '执行中',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: '项',
    coworkTodoCompleted: '已完成',
    coworkTodoInProgress: '进行中',
    coworkTodoPending: '待处理',
    coworkTodoUntitled: '未命名待办',
    coworkTodoUnknownStatus: '未知状态',
    coworkDangerousOperation: '警告：此操作可能会修改文件或执行系统命令，请仔细检查。',
    coworkApprove: '允许',
    coworkDeny: '拒绝',
    coworkConfirmSelection: '提交当前选择',
    coworkDenyRequest: '直接拒绝请求',
    coworkQuestionWizardTitle: '需要您的确认',
    coworkQuestionWizardSkip: '跳过',
    coworkQuestionWizardPrevious: '上一个',
    coworkQuestionWizardNext: '下一个',
    coworkQuestionWizardSubmit: '提交',
    coworkQuestionWizardOther: '其他',
    coworkQuestionWizardOtherPlaceholder: '请输入自定义答案...',
    coworkQuestionWizardSelectAtLeastOne: '请至少选择一个选项',
    coworkQuestionWizardAnswerRequired: '请选择或输入答案',
    coworkWelcome: '开始协作',
    coworkDescription: '7×24 小时帮你干活的全场景个人助理 Agent',
    coworkNewSession: '新会话',
    coworkContinuePlaceholder: '继续对话...',
    updateAvailablePill: '有新版本',
    updateAvailableTitle: '检测到新版本',
    updateAvailableMessage: '检测到新版本，请前往官网下载并覆盖安装。',
    updateAvailableConfirm: '立即更新',
    updateAvailableCancel: '取消',
    updateOpenFailed: '打开下载页面失败',
    updateDownloading: '正在下载更新...',
    updateDownloadCancel: '取消下载',
    updateInstalling: '正在安装更新，请稍候...',
    updateInstallingHint: '安装完成后应用将自动重启',
    updateDownloadFailed: '下载失败',
    updateInstallFailed: '安装失败',
    updateRetry: '重试',
    checkForUpdate: '检查更新',
    updateChecking: '检查中...',
    updateUpToDate: '已是最新版本',
    updateCheckFailed: '检查失败',
    coworkStartingSession: '正在启动会话...',
    coworkPreparingEnvironment: '准备环境中，请稍候',
    coworkAddFile: '添加文件',
    coworkDropFileHint: '拖拽文件到此处，或直接粘贴文件',
    coworkAddImage: '添加图片',
    coworkInputFileLabel: '输入文件',
    imageNotSupportedByModel: '当前模型可能不支持图片输入。图片仍会发送，但模型可能无法分析。',
    coworkAttachmentRemove: '移除',
    coworkShareSession: '分享',
    coworkExportImageInProgress: '正在导出图片...',
    coworkExportImageSuccess: '图片导出成功',
    coworkExportImageFailed: '导出图片失败',
    deleteSession: '删除任务',
    deleteTaskConfirmTitle: '确认删除任务',
    deleteTaskConfirmMessage: '此操作无法撤销，任务的所有消息记录将被永久删除。',
    batchOperations: '批量操作',
    batchSelectAll: '全选',
    batchDelete: '删除',
    batchCancel: '取消',
    batchDeleteConfirmTitle: '确认批量删除',
    batchDeleteConfirmMessage: '确定要删除选中的 {count} 个任务吗？此操作不可撤销。',
    back: '返回',
    browse: '浏览',
    addFolder: '添加文件夹',
    recentFolders: '最近使用',
    noFolderSelected: '未选择文件夹',
    coworkSelectFolderFirst: '请选择任务目录后再提交',
    noRecentFolders: '暂无最近文件夹',
    coworkOpenFolder: '打开文件夹',

    // Skills
    skills: '技能',
      flows: '流程',
    searchSkills: '搜索技能',
    manageSkills: '管理技能',
    officialSkills: '官方技能',
    addSkill: '添加',
    uploadSkillZip: '上传 .zip',
    uploadSkillFolder: '上传文件夹',
    importFromGithub: '从 GitHub 导入',
    githubImportTitle: '从 GitHub 导入',
    githubImportDescription: '支持仓库链接与子目录链接；若仓库内有多个技能，将自动全部导入。',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: '例如：owner/repo 或 GitHub tree/blob 链接',
    githubImportExamples: '示例：owner/repo；https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: '导入',
    importingSkill: '导入中...',
    official: '官方',
    noSkillsAvailable: '暂无可用技能',
    skillsDescription: '为您的智能体提供预封装且可重复的最佳实践与工具',
    skillInstalled: '已安装',
    skillMarketplace: '技能市场',
    skillMarketplaceEmpty: '暂无可用技能',
    skillCategoryAll: '全部',
    skillInstall: '安装',
    skillInstalling: '安装中',
    skillInstallFailed: '安装失败',
    skillAlreadyInstalled: '已安装',
    skillDetailVersion: '版本',
    skillDetailSource: '来源',
    skillDetailAuthor: '作者',
    skillsRoot: '技能目录',
    skillSourcePlaceholder: 'Git URL 或本地路径',
    downloadSkill: '下载技能',
    downloadingSkill: '正在下载...',
    deleteSkill: '删除技能',
    skillDeleteConfirm: '确定删除技能“{name}”吗？',
    skillDeleteFailed: '删除技能失败',
    skillBuiltInCannotDelete: '系统内置技能不允许删除',
    skillDownloadFailed: '下载技能失败',
    skillUpdateFailed: '更新技能失败',
    activeSkill: '当前技能',
    clearSkill: '清除技能',
    clearAll: '全部清除',
    clearAllSkills: '清除所有已选技能',

    // MCP 服务
    mcpServers: 'MCP',
    mcpDescription: '配置和管理 MCP（Model Context Protocol）服务器，为您的智能体扩展工具能力',
    searchMcpServers: '搜索 MCP 服务',
    addMcpServer: '自定义',
    editMcpServer: '编辑 MCP 服务',
    deleteMcpServer: '删除 MCP 服务',
    mcpServerName: '服务名称',
    mcpServerNamePlaceholder: '输入服务名称',
    mcpServerDescription: '描述',
    mcpServerDescriptionPlaceholder: '描述此 MCP 服务的用途',
    mcpTransportType: '传输类型',
    mcpCommand: '命令',
    mcpCommandPlaceholder: '例如: node, npx, uvx, python',
    mcpArgs: '参数',
    mcpArgsPlaceholder: '每行一个参数',
    mcpEnvVars: '环境变量',
    mcpUrl: 'URL',
    mcpUrlPlaceholder: '例如: http://localhost:3000/mcp',
    mcpHeaders: 'HTTP 请求头',
    mcpHeaderKey: '键',
    mcpHeaderValue: '值',
    noMcpServersAvailable: '暂无 MCP 服务',
    mcpDeleteConfirm: '确定删除 MCP 服务"{name}"吗？',
    mcpDeleteFailed: '删除 MCP 服务失败',
    mcpCreateFailed: '创建 MCP 服务失败',
    mcpUpdateFailed: '更新 MCP 服务失败',
    mcpNameRequired: '请填写服务名称',
    mcpCommandRequired: 'stdio 类型需要填写命令',
    mcpUrlRequired: 'SSE/HTTP 类型需要填写 URL',
    mcpNameExists: '服务名称已存在',
    mcpTransportStdio: '标准输入输出 (stdio)',
    mcpTransportSse: '服务器推送事件 (SSE)',
    mcpTransportHttp: 'HTTP 流式传输',
    addKeyValue: '添加',
    saveMcpServer: '保存',
    // MCP 市场 & 注册表
    mcpInstalled: '已安装',
    mcpMarketplace: '市场',
    mcpCustom: '自定义',
    mcpCustomDescription: '手动配置 MCP 服务器',
    mcpResetForm: '重置',
    mcpInstall: '安装',
    mcpInstallFromUrl: '通过 URL 安装',
    mcpInstallFromUrlTitle: '通过 URL 安装 MCP',
    mcpInstallFromUrlPlaceholder: '输入 npm 包名或 URL',
    mcpInstallFromUrlHint: '支持 npm 包名（如 @modelcontextprotocol/server-filesystem）、npx 命令或 HTTP/HTTPS URL',
    mcpRequiredConfig: '必填配置',
    mcpOptionalConfig: '可选配置',
    mcpViewOnGithub: '在 GitHub 上查看',
    mcpNoInstalledServers: '尚未安装任何 MCP 服务',
    mcpCategoryAll: '全部',
    mcpCategorySearch: '搜索',
    mcpCategoryBrowser: '浏览器',
    mcpCategoryDeveloper: '开发工具',
    mcpCategoryProductivity: '效率工具',
    mcpCategoryDesign: '设计',
    mcpCategoryDataApi: '数据 & API',
    mcpDesc_tavily: '实时网页搜索、智能数据提取和网站爬取',
    mcpDesc_github: 'GitHub 平台集成：仓库、Issues、PR、Actions 管理',
    mcpDesc_gitlab: 'GitLab API 集成：项目管理、合并请求、流水线',
    mcpDesc_context7: '为 AI 编程提供最新的库文档和代码示例',
    mcpDesc_google_drive: 'Google Drive 文件访问和搜索，自动导出 Workspace 文件',
    mcpDesc_gmail: 'Gmail 邮件管理：读取、发送、搜索邮件，支持自动认证',
    mcpDesc_google_calendar: 'Google Calendar 日程管理：创建、查询、更新日历事件',
    mcpDesc_notion: 'Notion API：搜索、创建/更新页面、管理数据库',
    mcpDesc_slack: 'Slack 工作区：频道管理、消息发送、用户查询',
    mcpDesc_todoist: '任务管理：创建、更新、完成和组织待办事项',
    mcpDesc_playwright: '高级浏览器自动化，支持 Chromium/Firefox/WebKit',
    mcpDesc_canva: 'Canva 设计平台：创建和管理设计、模板操作',
    mcpDesc_firecrawl: '网页抓取与数据提取：支持批处理、结构化提取和内容分析',
    mcpDesc_fetch: '网页内容抓取和 HTML 转 Markdown，适合 LLM 消费',

    // 邮箱技能配置
    emailTab: '邮箱',
    emailConfig: '邮箱配置',
    emailProvider: '邮箱服务商',
    emailSelectProvider: '请选择邮箱服务商',
    emailCustomProvider: '自定义',
    emailAddress: '邮箱地址',
    emailPassword: '密码 / 授权码',
    emailPasswordPlaceholder: '密码或应用专用密码',
    emailAdvancedSettings: '高级设置',
    emailMailbox: '默认收件箱',
    emailConfigSaved: '邮箱配置已保存',
    emailConfigError: '保存配置失败',
    emailHintGmail: '如果开启了两步验证，请使用应用专用密码（App Password）',
    emailHint163: '请使用授权码，而非账户密码。需先在网页端设置中开启 IMAP/SMTP 服务',
    emailHintQQ: '请使用授权码，而非账户密码。需先在网页端设置中开启 IMAP/SMTP 服务',

    // 文件操作
    openFile: '打开文件',
    openFolder: '打开文件夹',
    showInFolder: '在文件夹中显示',
    outputFiles: '输出文件',
    openFileFailed: '打开文件失败',
    fileCreated: '文件已创建',

    // IM Bot
    imBot: 'IM 机器人',
    dingtalk: '钉钉',
    feishu: '飞书',
    qq: 'QQ',
    telegram: 'Telegram',
    discord: 'Discord',
    nim: '云信',
    xiaomifeng: '小蜜蜂',
    wecom: '企业微信',
    connected: '已连接',
    disconnected: '未连接',
    kickedByOtherClient: '账号已在其它地方登录',
    starting: '启动中',
    start: '启动',
    stop: '停止',
    messageType: '消息类型',
    domain: '域名',
    feishuChina: '飞书（中国）',
    renderMode: '渲染模式',
    textMode: '文本',
    cardMode: '卡片',
    chatSettings: '对话设置',
    enableSkills: '启用技能',
    systemPrompt: '系统提示词',
    systemPromptPlaceholder: '为 IM 机器人设置自定义指令...',
    saveConfig: '保存配置',
    imConnectivitySectionTitle: '连通性诊断',
    imConnectivityTest: '测试连通性',
    imConnectivityRetest: '重新测试',
    imConnectivityTesting: '测试中...',
    imConnectivityNoResult: '尚未执行诊断。建议启用后立即测试。',
    imConnectivityLastChecked: '最近测试',
    imConnectivitySuggestion: '建议',
    imConnectivityVerdict_pass: '可对话',
    imConnectivityVerdict_warn: '需关注',
    imConnectivityVerdict_fail: '不可用',
    imConnectivityCheckTitle_missing_credentials: '配置项缺失',
    imConnectivityCheckTitle_auth_check: '凭证鉴权',
    imConnectivityCheckTitle_gateway_running: 'IM 渠道启用状态',
    imConnectivityCheckTitle_inbound_activity: '入站消息活动',
    imConnectivityCheckTitle_outbound_activity: '出站消息活动',
    imConnectivityCheckTitle_platform_last_error: '平台最近错误',
    imConnectivityCheckTitle_feishu_group_requires_mention: '飞书群聊触发规则',
    imConnectivityCheckTitle_feishu_event_subscription_required: '飞书事件订阅要求',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord 群聊触发规则',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: '钉钉会话权限',
    imConnectivityCheckTitle_nim_p2p_only_hint: '云信私聊模式',
    imConnectivityCheckSuggestion_missing_credentials: '补全必填配置项后重试。',
    imConnectivityCheckSuggestion_auth_check: '核对平台凭证、应用权限和发布状态。',
    imConnectivityCheckSuggestion_gateway_running: '若显示未启用，请点击对应 IM 渠道胶囊按钮启用；启用后确认网络可访问平台服务。',
    imConnectivityCheckSuggestion_inbound_activity: '向机器人发一条测试消息；群聊场景请 @机器人。',
    imConnectivityCheckSuggestion_outbound_activity: '检查机器人发消息权限、可见范围和会话回包权限。',
    imConnectivityCheckSuggestion_platform_last_error: '根据错误提示修复后再重测。',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: '在群聊中使用 @机器人 + 内容。',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: '在飞书后台开启 im.message.receive_v1 并发布版本。',
    imConnectivityCheckSuggestion_discord_group_requires_mention: '在频道中使用 @机器人 + 内容。',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: '在 @BotFather 调整 Privacy Mode 设置。',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: '确认机器人已加入目标会话并允许收发消息。',
    imConnectivityCheckSuggestion_nim_p2p_only_hint: '通过私聊方式向机器人账号发送消息。',
    nimAccountPlaceholder: '机器人账号ID',
    nimAccountHint: '在云信控制台"账号管理"中创建的 IM 账号 ID',
    nimCredentialsGuide: '如何获取云信凭证：',
    nimGuideStep1: '登录网易云信控制台（yunxin.163.com）',
    nimGuideStep2: '创建或选择应用，获取 App Key',
    nimGuideStep3: '在"账号数-子功能配置"中创建 IM 账号（accid）',
    nimGuideStep4: '为该账号生成 Token（密码）- 建议长期有效',
    nimAppKeyHint: '从云信控制台应用信息中获取',
    nimTokenHint: '为该账号生成的访问凭证（建议设置为长期有效）',
    nimAccountWhitelist: '白名单账号',
    nimAccountWhitelistHint: '填写允许与机器人对话的云信账号，多个账号用逗号分隔。留空则不限制，响应所有账号的消息。',
    nimTeamPolicy: '群消息策略',
    nimTeamPolicyDisabled: '禁用 - 不响应群消息',
    nimTeamPolicyOpen: '开放 - 响应所有群的@消息',
    nimTeamPolicyAllowlist: '白名单 - 仅响应指定群的@消息',
    nimTeamPolicyHint: '群消息仅响应@机器人的消息',
    nimTeamAllowlist: '群白名单',
    nimTeamAllowlistHint: '填写允许响应的群ID，多个用逗号分隔',
    nimQChatEnabled: '启用圈组 (QChat)',
    nimQChatEnabledHint: '订阅圈组消息，仅响应@机器人的消息',
    nimQChatServerIds: '圈组服务器 ID',
    nimQChatServerIdsPlaceholder: '留空自动发现所有已加入的服务器',
    nimQChatServerIdsHint: '指定要订阅的服务器 ID，多个用逗号分隔。留空则自动订阅所有已加入的服务器。',
    xiaomifengClientIdPlaceholder: '小蜜蜂助理Client ID',

    // 通用设置
    autoLaunch: '开机自启动',
    autoLaunchDescription: '系统启动时自动运行应用',
    useSystemProxy: '使用系统代理',
    useSystemProxyDescription: '开启后网络请求将跟随系统代理（保存后生效）',

    // 定时任务
    scheduledTasks: '定时任务',
    scheduledTasksTitle: '定时任务',
    scheduledTasksNewTask: '新建任务',
    scheduledTasksEmptyState: '暂无定时任务',
    scheduledTasksEmptyHint: '创建定时任务，让 AI 按计划自动执行',

    // 任务管理
    taskManager: '記錄助理',
    taskManagerTitle: '任务管理',
    taskManagerNewTask: '新建任务',
    taskManagerEmptyState: '暂无任务',
    taskManagerEmptyHint: '创建任务或从聊天中提取任务',
    taskManagerListColTitle: '标题',
    calendar: '日历',
    list: '列表',
    chat: '聊天',
    scheduledTasksListColSchedule: '计划于',
    scheduledTasksListColStatus: '状态',
    scheduledTasksListColMore: '更多',
    scheduledTasksTabTasks: '任务',
    scheduledTasksTabHistory: '历史',
    scheduledTasksHistoryEmpty: '暂无运行记录',
    scheduledTasksHistoryColTitle: '标题',
    scheduledTasksHistoryColTime: '执行时间',
    scheduledTasksHistoryColStatus: '状态',
    scheduledTasksFormName: '标题',
    scheduledTasksFormNamePlaceholder: '输入任务标题',
    scheduledTasksFormDescription: '描述',
    scheduledTasksFormDescriptionPlaceholder: '可选的任务描述',
    scheduledTasksFormScheduleType: '计划',
    scheduledTasksFormScheduleModeOnce: '不重复',
    scheduledTasksFormScheduleModeDaily: '每天',
    scheduledTasksFormScheduleModeWeekly: '每周',
    scheduledTasksFormScheduleModeMonthly: '每月',
    scheduledTasksFormWeekSun: '周日',
    scheduledTasksFormWeekMon: '周一',
    scheduledTasksFormWeekTue: '周二',
    scheduledTasksFormWeekWed: '周三',
    scheduledTasksFormWeekThu: '周四',
    scheduledTasksFormWeekFri: '周五',
    scheduledTasksFormWeekSat: '周六',
    scheduledTasksFormValidationTimeRequired: '请选择时间',
    scheduledTasksFormValidationWorkingDirectoryRequired: '请选择任务工作目录',
    scheduledTasksFormMonthDaySuffix: '日',
    scheduledTasksFormScheduleAt: '定时执行',
    scheduledTasksFormScheduleAtHint: '在指定时间执行一次',
    scheduledTasksFormScheduleInterval: '间隔执行',
    scheduledTasksFormScheduleIntervalHint: '按固定间隔重复执行',
    scheduledTasksFormScheduleCron: 'Cron 表达式',
    scheduledTasksFormScheduleCronHint: '使用 Cron 表达式定义复杂调度',
    scheduledTasksFormDatetime: '执行时间',
    scheduledTasksFormInterval: '间隔时间',
    scheduledTasksFormIntervalMinutes: '分钟',
    scheduledTasksFormIntervalHours: '小时',
    scheduledTasksFormIntervalDays: '天',
    scheduledTasksFormCronExpression: 'Cron 表达式',
    scheduledTasksFormCronPlaceholder: '例如: */5 * * * * (每5分钟)',
    scheduledTasksFormCronHelp: '格式: 分 时 日 月 周 (5段)',
    scheduledTasksFormPrompt: '执行提示词',
    scheduledTasksFormPromptPlaceholder: '输入要执行的提示词...',
    scheduledTasksFormWorkingDirectory: '工作目录',
    scheduledTasksFormWorkingDirectoryPlaceholder: '输入项目路径',
    scheduledTasksFormSystemPrompt: '系统提示词',
    scheduledTasksFormSystemPromptPlaceholder: '可选的系统提示词...',
    scheduledTasksFormExecutionMode: '执行模式',
    scheduledTasksFormExecutionModeAuto: '自动',
    scheduledTasksFormExecutionModeLocal: '本地',
    scheduledTasksFormExecutionModeSandbox: '沙箱',
    scheduledTasksFormEnabled: '启用任务',
    scheduledTasksFormCreate: '创建任务',
    scheduledTasksFormUpdate: '更新任务',
    scheduledTasksFormValidationNameRequired: '请输入任务标题',
    scheduledTasksFormValidationPromptRequired: '请输入执行提示词',
    scheduledTasksFormValidationDatetimeFuture: '执行时间必须在未来',
    scheduledTasksFormValidationIntervalPositive: '间隔时间必须大于 0',
    scheduledTasksFormValidationCronRequired: '请输入 Cron 表达式',
    scheduledTasksEdit: '编辑',
    scheduledTasksDelete: '删除',
    scheduledTasksDeleteConfirm: '确定要删除任务「{name}」吗？此操作不可撤销。',
    scheduledTasksRun: '立即运行',
    scheduledTasksStop: '停止',
    scheduledTasksEnabled: '已启用',
    scheduledTasksDisabled: '已禁用',
    scheduledTasksDetail: '任务详情',
    scheduledTasksConfiguration: '配置信息',
    scheduledTasksSchedule: '计划',
    scheduledTasksPrompt: '提示词',
    scheduledTasksWorkingDirectory: '工作目录',
    scheduledTasksSystemPrompt: '系统提示词',
    scheduledTasksExecutionMode: '执行模式',
    scheduledTasksStatus: '运行状态',
    scheduledTasksNextRun: '下次运行',
    scheduledTasksLastRun: '上次运行',
    scheduledTasksLastDuration: '上次耗时',
    scheduledTasksLastError: '最近错误',
    scheduledTasksConsecutiveErrors: '连续错误',
    scheduledTasksRunHistory: '运行历史',
    scheduledTasksNoRuns: '暂无运行记录',
    scheduledTasksLoadMore: '加载更多',
    scheduledTasksManual: '手动',
    scheduledTasksScheduled: '定时',
    scheduledTasksViewSession: '查看会话',
    scheduledTasksStatusSuccess: '成功',
    scheduledTasksStatusError: '失败',
    scheduledTasksStatusRunning: '运行中',
    scheduledTasksStatusIdle: '空闲',
    scheduledTasksNotSet: '未设置',
    scheduledTasksNone: '无',
    scheduledTasksScheduleAtLabel: '定时',
    scheduledTasksScheduleIntervalLabel: '间隔',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: '每',
    scheduledTasksAutoDisabledErrors: '连续错误过多，任务已自动禁用',
    scheduledTasksCreateFailed: '创建任务失败',
    scheduledTasksUpdateFailed: '更新任务失败',
    scheduledTasksDeleteFailed: '删除任务失败',
    scheduledTasksRunFailed: '运行任务失败',
    scheduledTasksStopFailed: '停止任务失败',
    scheduledTasksFormExpiresAt: '到期时间',
    scheduledTasksFormOptional: '（可选）',
    scheduledTasksFormExpiresAtHint: '可选，到期后任务不再运行',
    scheduledTasksFormExpiresAtClear: '清除',
    scheduledTasksFormExpiresAtNone: '永不过期',
    scheduledTasksDetailExpiresAt: '到期时间',
    scheduledTasksFormNotify: 'IM 通知',
    scheduledTasksFormNotifyHint: '可选，任务完成后通过 IM 发送结果通知',
    scheduledTasksFormNotifyDingtalk: '钉钉',
    scheduledTasksFormNotifyFeishu: '飞书',
    scheduledTasksFormNotifyQq: 'QQ',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNim: '云信',
    scheduledTasksFormNotifyXiaomifeng: '小蜜蜂',
    scheduledTasksFormNotifyWecom: '企业微信',
    scheduledTasksFormNotifyNone: '无',
    scheduledTasksFormNotifyNotConfigured: '未配置',
    scheduledTasksDetailNotify: '通知',
    scheduledTasksToggleWarningAtPast: '该任务的执行时间已过，启用后将不会运行',
    scheduledTasksToggleWarningExpired: '该任务已过期，启用后将不会运行',
  },
  'zh-TW': {
    manageContacts: '管理聯絡人',
    alertContacts: '跟急聯絡人',
    alertContactsTitle: '跟急聯絡人',
    alertContactsDesc: '管理將接收行為跟急的聯絡人',
    save: '儲存',
    cancel: '取消',
    saving: '儲存中...',
    create: '建立',
    delete: '刪除',
    optional: '可選',
    user: '使用者',
    login: '登入',
    inDevelopment: '正在開發中',
    settings: '設定',
    general: '通用',
    model: '模型',
    shortcuts: '快捷鍵',
    about: '關於',
    aboutVersion: '版本',
    aboutContactEmail: '聯絡信箱',
    aboutUserManual: '使用者手冊',
    aboutServiceTerms: '服務條款',
    aboutExportLogs: '匯出日誌',
    aboutExportingLogs: '匯出中...',
    aboutExportLogsFailed: '匯出日誌失敗',
    aboutExportLogsSuccess: '日誌匯出成功',
    aboutExportLogsPartial: '日誌匯出成功（缺失日誌已按空檔案補齊）',
    testMode: '測試模式',
    theme: '主題',
    appearance: '外觀',
    language: '語言',
    light: '淺色',
    dark: '深色',
    system: '跟隨系統',
    chinese: '中文',
    traditionalChinese: '繁體中文',
    english: 'English',
    apiKey: 'API Key',
    apiKeyPlaceholder: '輸入你的 API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: '輸入 API 基礎 URL',
    baseUrlHint1: '一般只需填寫網域，系統自動補全路徑',
    baseUrlHintExample1: 'https://api.siliconflow.cn',
    baseUrlHint2: '非標準路徑可填寫完整地址',
    baseUrlHintExample2: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
    currentModel: '目前模型',
    availableModels: '可用模型列表',
    modelSwitchHint: '在聊天介面可以切換使用的模型',
    enabled: '已啟用',
    disabled: '已停用',
    providerStatusOn: '已開啟',
    providerStatusOff: '未開啟',
    providerSettings: '提供商設定',
    modelProviders: '模型提供商',
    projectConnections: '專案連線',
    integrationProjects: '連線專案',
    integrationAddProject: '新增',
    integrationNewProject: '新專案連線',
    integrationDescription: '連線任何提供 OpenAPI 3.x 文件的專案，並管理可供 AI 使用的介面。',
    integrationProjectName: '專案名稱',
    integrationAuthType: '認證方式',
    integrationAuthNone: '無需認證',
    integrationHeaderName: 'API Key 請求標頭',
    integrationSecretUnchanged: '已設定；留空則保持不變',
    integrationDiscover: '識別 API',
    integrationApiDirectory: 'API 介面目錄',
    integrationOperations: '個介面',
    integrationNoProjects: '尚未新增專案連線',
    integrationNoEndpoints: '尚未識別到介面，請先儲存並識別 OpenAPI。',
    integrationNameRequired: '請填寫專案名稱',
    integrationBaseUrlRequired: '請填寫 API Base URL',
    integrationSaved: '專案連線已儲存',
    integrationSaveFailed: '儲存專案連線失敗',
    integrationLoadFailed: '載入專案連線失敗',
    integrationTestFailed: '連線測試失敗',
    integrationDiscoverySuccess: '成功識別',
    integrationDiscoveryFailed: '識別 OpenAPI 失敗',
    integrationDeleteConfirm: '確定刪除此專案連線及其 API 設定嗎？',
    integrationDeleteFailed: '刪除專案連線失敗',
    integrationEndpointUpdateFailed: '更新介面權限失敗',
    integrationPolicyDisabled: '停用',
    integrationPolicyManual: '僅手動呼叫',
    integrationPolicyAgentRead: '允許 AI 讀取',
    integrationPolicyAgentWrite: '允許 AI 寫入',
    integrationPolicyAutomatic: '允許主動介入',
    integrationConnectionEnabled: '連線已啟用',
    integrationConnectionDisabled: '連線已停用',
    integrationAiToolsAuthorized: '個 AI 工具已授權',
    integrationNoAiTools: '尚未授權任何介面給 AI',
    integrationAiAuthorizationHint: 'API Key 只負責連線認證；介面還需要授權後才會成為 AI 工具。寫入介面請在下方逐個授權。',
    integrationAuthorizeAllReads: '授權全部 GET',
    integrationAuthorizing: '授權中...',
    integrationReadAuthorizationSuccess: '已授權讀取介面',
    integrationReadAuthorizationFailed: '批次授權讀取介面失敗',
    demoIntegrationWarning: '⚠️ 演示模式：請勿連接正在使用中的真實 API。此功能僅供演示和探索，連接的 API Key 和設定可能被他人查看。',
    addModel: '新增模型',
    editModel: '編輯模型',
    addNewModel: '新增新模型',
    modelName: '模型名稱',
    modelId: '模型ID',
    modelNameAndIdRequired: '請填寫模型名稱和模型ID',
    modelIdExists: '模型ID已存在，請使用不同的ID',
    ollamaModelName: '模型名稱',
    ollamaModelNameHint: '輸入 Ollama 中已安裝的模型名稱，如 qwen3:8b、lfm2:latest',
    ollamaModelNamePlaceholder: 'qwen3:8b',
    ollamaDisplayName: '顯示名稱（可選）',
    ollamaDisplayNameHint: '自訂在列表中顯示的名稱，留空則使用模型名稱',
    ollamaDisplayNamePlaceholder: '我的 Qwen3 模型',
    ollamaModelNameRequired: '請填寫模型名稱',
    supportsImageInput: '支援圖像輸入',
    imageInput: '圖像',
    noModelsAvailable: '暫無可用模型',
    addFirstModel: '新增第一個模型',
    testConnection: '測試連線',
    connectionTestResult: '連線測試結果',
    testing: '測試中...',
    connectionSuccess: '連線成功',
    connectionFailed: '連線失敗',
    noModelsConfigured: '請先新增模型',
    apiFormat: 'API 格式',
    apiFormatNative: 'Anthropic 相容',
    apiFormatOpenAI: 'OpenAI 相容',
    apiFormatHint: '請選擇 API 協定相容格式：Anthropic 相容或 OpenAI 相容',
    zhipuCodingPlanHint: '啟用後使用 GLM Coding Plan 專屬 API 端點',
    zhipuCodingPlanEndpointHint: '使用 GLM Coding Plan 時，系統將自動切換到 Coding 專屬端點',
    qwenCodingPlanHint: '啟用後使用阿里雲百煉 Coding Plan 專屬 API 端點',
    qwenCodingPlanEndpointHint: '使用 Coding Plan 時，需要設定專屬的 API Key（格式：sk-sp-xxxxx）',
    volcengineCodingPlanHint: '啟用後使用火山引擎 Coding Plan 專屬 API 端點',
    volcengineCodingPlanEndpointHint: '使用 Coding Plan 時，系統將自動切換到 Coding 專屬端點',
    moonshotCodingPlanHint: '啟用後使用 Moonshot Coding Plan 專屬 API 端點',
    moonshotCodingPlanEndpointHint: '使用 Coding Plan 時，系統將自動切換到 Coding 專屬端點',
    import: '匯入',
    export: '匯出',
    importProvidersFailed: '匯入失敗',
    exportProvidersFailed: '匯出失敗',
    invalidProvidersFile: '匯入檔案格式不正確',
    decryptProvidersFailed: '金鑰解密失敗，請確認檔案由目前裝置匯出',
    decryptProvidersPartial: '部分金鑰無法解密，已保留本地金鑰或留空，請手動檢查',
    password: '密碼',
    confirmPassword: '確認密碼',
    enterPassword: '請輸入密碼',
    enterPasswordAgain: '請再次輸入密碼',
    exportPasswordTitle: '設定匯出密碼',
    importPasswordTitle: '輸入匯入密碼',
    exportPasswordHint: '此密碼用於加密你的 API 金鑰，匯入時需要使用相同的密碼',
    importPasswordHint: '請輸入匯出時設定的密碼',
    passwordRequired: '請輸入密碼',
    passwordMismatch: '兩次輸入的密碼不一致',
    passwordTooShort: '密碼長度至少為4位',
    wrongPassword: '密碼錯誤，請檢查後重試',
    keyboardShortcuts: '鍵盤快捷鍵',
    newChat: '新建任務',
    search: '搜尋任務',
    openSettings: '開啟設定',
    close: '關閉',
    loginNotAvailable: '登入功能暫未開放',
    collapse: '收起',
    expand: '展開',
    featureInDevelopment: '正在開發中',
    failedToLoadSettings: '載入設定失敗',
    failedToSaveSettings: '儲存設定失敗',
    loading: '載入中...',
    conversations: '對話',
    noConversations: '暫無對話',
    createNewChat: '新建對話',
    deleteConversation: '刪除對話',
    renameConversation: '重新命名',
    moveToProject: '移至專案',
    pinConversation: '置頂聊天',
    unpinConversation: '取消置頂',
    noProject: '無專案',
    noProjects: '暫無專案',
    confirmDelete: '確認刪除',
    sequenceDetect: '序列檢測',
    confirmDeleteMessage: '確定要刪除這個對話嗎？此操作不可撤銷。',
    searchChats: '搜尋聊天',
    searchConversations: '搜尋任務...',
    searchNoResults: '未找到符合任務',
    projects: '專案',
    yourChats: '你的聊天',
    createProject: '新專案',
    projectNamePlaceholder: '專案名稱',
    projectColorLabel: '顏色',
    projectIconLabel: '圖示',
    project: '專案',
    projectHistory: '歷史記錄',
    projectPrompt: '提示詞',
    projectPromptPlaceholder: '為該專案設定提示詞',
    projectSettings: '專案設定',
    projectNameLabel: '專案名稱',
    deleteProject: '刪除專案',
    confirmDeleteProject: '確定要刪除這個專案嗎？專案內聊天將移回到聊天列表。此操作不可撤銷。',
    folderIconDefault: '預設',
    folderIconHealth: '健康',
    folderIconStudy: '學習',
    folderIconMath: '數學',
    folderIconWork: '工作',
    folderIconCode: '程式碼',
    folderIconIdea: '靈感',
    sendMessage: '傳送訊息',
    typeMessage: '詢問任何問題...',
    quickPrompt: '詢問任何問題',
    regenerateResponse: '重新生成回覆',
    copyToClipboard: '複製到剪貼簿',
    messageCopied: '訊息已複製',
    clearConversation: '清空對話',
    confirmClearConversation: '確定要清空目前對話嗎？此操作不可撤銷。',
    today: '今天',
    yesterday: '昨天',
    daysAgo: '天前',
    justNow: '剛剛',
    minutesAgo: '分鐘前',
    hoursAgo: '小時前',
    welcomeMessage: '我能幫你做什麼呢？',
    thinking: '思考中...',
    reasoning: '思考過程',
    editMessage: '編輯訊息',
    emptyMessage: '空訊息',
    artifactOpen: '開啟',
    artifactView: '檢視',
    artifactViewing: '預覽中',
    artifactPreview: '預覽',
    artifactCode: '程式碼',
    imageLimitReached: '最多上傳 10 張圖片',
    imageReadError: '讀取圖片失敗',
    imageInputNotSupported: '目前模型不支援圖像輸入',
    selectModel: '選擇模型',
    errorOccurred: '發生錯誤',
    tryAgain: '請重試',
    networkError: '網路錯誤',
    apiKeyRequired: '需要設定 API 金鑰',
    configureApiKey: '請在設定中設定您的 API 金鑰',
    initializationError: '初始化應用程式失敗。請檢查您的設定。',
    apiKeyNotConfigured: 'API 金鑰未設定。請在設定中設定您的 API 金鑰。',
    cowork: '{appName}',
    coworkSandbox: '沙箱',
    coworkSettings: 'MednnectAI 設定',
    coworkHistory: '任務記錄',
    coworkNoSessions: '暫無任務記錄',
    coworkPinSession: '置頂任務',
    coworkUnpinSession: '取消置頂',
    coworkSessionActions: '更多操作',
    coworkPlaceholder: '分配一個任務或提問任何問題',
    coworkWorkingDirectory: '工作目錄',
    coworkWorkingDirectoryPlaceholder: '輸入專案路徑',
    coworkWorkingDirectoryHint: 'MednnectAI 將在此目錄下執行命令',
    coworkSystemPrompt: '系統提示詞',
    coworkSystemPromptPlaceholder: '為 MednnectAI 設定自訂指令...',
    coworkSystemPromptHint: '可選的系統提示詞，用於自訂 MednnectAI 的行為',
    coworkModelSettingsRequired: '請先在模型設定中設定可用模型與 API Key。',
    coworkModelSettingsTitle: '模型設定',
    coworkModelSettingsHint: 'MednnectAI 使用模型設定中的目前模型與提供商設定。',
    coworkModelSettingsAction: '前往模型設定',
    coworkApiConfigTitle: 'API 設定',
    coworkApiConfigHint: '支援 Anthropic 相容與 OpenAI 相容協定（OpenAI 相容透過本地轉換服務接入）。',
    coworkExecutionMode: '執行模式',
    coworkExecutionModeAuto: '自動（優先沙箱）',
    coworkExecutionModeLocal: '本地執行',
    coworkExecutionModeSandbox: '僅沙箱（內建 VM）',
    coworkExecutionModeAutoHint: '優先使用內建 VM 沙箱，不可用時回退本地',
    coworkExecutionModeLocalHint: '始終在本機執行',
    coworkExecutionModeSandboxHint: '要求內建 VM 沙箱可用，否則報錯',
    coworkMemoryTitle: '記憶',
    coworkMemoryEnabled: '啟用使用者記憶',
    coworkMemoryEnabledHint: '將穩定事實注入到系統提示詞中的 <userMemories> 區塊。',
    coworkMemorySimpleHint: '建議開啟後直接使用下方「記憶條目管理」，無需額外設定。',
    coworkMemoryLlmJudgeEnabled: '啟用 LLM 二級判定',
    coworkMemoryLlmJudgeEnabledHint: '僅對規則邊界樣本呼叫模型複核，提升準確率（會增加少量 API 呼叫）。',
    coworkMemoryAutoWrite: '自動寫入記憶',
    coworkMemoryCaptureEachTurn: '啟用隱式更新',
    coworkMemoryGuardLevel: '寫入門檻',
    coworkMemoryGuardStrict: '嚴格',
    coworkMemoryGuardStandard: '標準',
    coworkMemoryGuardRelaxed: '寬鬆',
    coworkMemoryMaxResults: '注入條目上限',
    coworkMemoryMaxResultsHint: '可選範圍 1-60，建議 12',
    coworkMemoryMinScore: '最小相關性閾值',
    coworkMemoryMaxInjectChars: '最大注入字元數',
    coworkMemoryRecallInterval: '自動回憶間隔（輪）',
    coworkMemoryRecallIntervalHint: '每 N 輪自動注入一次記憶，建議 3',
    coworkMemoryCrudTitle: '記憶條目管理',
    coworkMemoryManageHint: '你可以在這裡檢視、搜尋、新增、編輯或刪除記憶內容。',
    coworkMemoryTotalLabel: '記憶總數',
    coworkMemoryActiveLabel: '生效中',
    coworkMemoryInactiveLabel: '暫不使用',
    coworkMemoryStatusActive: '生效中',
    coworkMemoryStatusInactive: '暫不使用',
    coworkMemoryStatusDeleted: '已刪除',
    coworkMemoryUpdatedAt: '最後更新',
    coworkMemoryEditingTag: '正在編輯目前記憶',
    coworkMemoryRebuildIndex: '重建索引',
    coworkMemoryRebuildSuccess: '記憶索引重建完成',
    coworkMemoryRebuildFailed: '記憶索引重建失敗',
    coworkMemoryStatsSummary: '已管理條目數',
    coworkMemorySearchPlaceholder: '搜尋記憶內容/來源',
    coworkMemoryCategoryAll: '全部分類',
    coworkMemoryEmpty: '暫無記憶條目',
    coworkMemoryCrudTextPlaceholder: '輸入要儲存的記憶內容',
    coworkMemoryCrudCreate: '新增條目',
    coworkMemoryCrudUpdate: '更新條目',
    coworkMemoryCrudSaveFailed: '儲存記憶條目失敗',
    coworkMemoryCrudDeleteFailed: '刪除記憶條目失敗',
    coworkMemoryAdvancedShow: '顯示進階設定',
    coworkMemoryAdvancedHide: '隱藏進階設定',
    coworkMemoryEmbeddingEnabled: '啟用本地 embedding 重排',
    coworkMemoryEmbeddingEnabledHint: '在詞法檢索基礎上用本地向量相似度重排結果，提升召回品質',
    coworkMemoryEmbeddingModel: 'Embedding 模型',
    coworkMemoryEmbeddingModelHint: '推薦 BAAI/bge-m3；可改為你已下載的其他 sentence-transformers 模型',
    coworkMemoryEmbeddingLocalModelPath: '本地模型目錄（可選）',
    coworkMemoryEmbeddingLocalModelPathHint: '填寫後優先載入本地目錄；留空時按模型名稱載入',
    coworkMemoryEmbeddingAutoDownload: '允許自動下載模型',
    coworkMemoryEmbeddingAutoDownloadHint: '關閉後必須提供本地模型目錄',
    coworkMemoryEmbeddingDownload: '下載 / 校驗模型',
    coworkMemoryEmbeddingDownloading: '下載中...',
    coworkMemoryEmbeddingDownloadHint: '手動觸發模型下載（或校驗本地模型目錄），下載過程可能較慢，請等待進度完成',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding 模型已就緒',
    coworkMemoryEmbeddingDownloadFailed: 'Embedding 模型下載失敗',
    coworkMemoryEmbeddingProgressPreparing: '準備下載任務',
    coworkMemoryEmbeddingProgressInit: '初始化環境',
    coworkMemoryEmbeddingProgressDownload: '下載模型檔案',
    coworkMemoryEmbeddingProgressLoad: '載入模型',
    coworkMemoryEmbeddingProgressEncode: '模型預熱',
    coworkMemoryEmbeddingProgressDone: '完成',
    coworkMemoryEmbeddingProgressError: '失敗',
    coworkMemoryEmbeddingWeight: '語意重排權重',
    coworkMemoryEmbeddingWeightHint: '範圍 0-1，值越大越依賴 embedding 相似度，建議 0.62',
    coworkSandboxManualInstallNotice: '目前未執行在沙箱模式。若需使用沙箱，請先手動安裝沙箱元件。',
    coworkSandboxManualInstallAction: '前往沙箱設定',
    coworkSandboxChecking: '正在檢測內建 VM 沙箱...',
    coworkSandboxUnsupported: '目前系統不支援內建 VM 沙箱',
    coworkSandboxRuntimeMissing: '未檢測到 VM 執行環境',
    coworkSandboxImageMissing: '未檢測到沙箱映像檔',
    coworkSandboxDownloading: '正在下載沙箱元件...',
    coworkSandboxInstall: '安裝沙箱',
    coworkSandboxInstalling: '正在安裝...',
    coworkSandboxSelectionBlocked: '目前不可用，請選擇自動或本地模式。',
    coworkSandboxBadge: '沙箱',
    coworkLocalBadge: '本地',
    coworkApiProviderModel: '從模型設定選擇',
    coworkApiProviderModelCustom: '自訂',
    coworkApiProviderModelHint: '僅顯示已啟用且已設定 API Key/地址的模型',
    coworkApiBaseUrl: 'API 基礎地址',
    coworkApiKey: 'API Key',
    coworkApiModel: '模型名稱',
    coworkApiKeyRequired: '需要填寫 API Key',
    coworkApiBaseUrlRequired: '需要填寫 API 地址',
    coworkApiModelRequired: '需要填寫模型名稱',
    coworkApiBaseUrlInvalid: 'API 地址格式無效',
    coworkApiConfigSaveFailed: '儲存 API 設定失敗',
    coworkApiConfigLoadFailed: '載入 API 設定失敗',
    coworkStatusIdle: '已停止',
    coworkStatusRunning: '執行中',
    coworkStatusCompleted: '已完成',
    coworkStatusError: '錯誤',
    coworkPermissionRequired: '需要權限確認',
    coworkPermissionDescription: 'MednnectAI 請求執行以下操作',
    coworkToolName: '工具名稱',
    coworkToolInput: '工具參數',
    coworkToolResult: '執行結果',
    coworkToolRunning: '執行中',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: '項',
    coworkTodoCompleted: '已完成',
    coworkTodoInProgress: '進行中',
    coworkTodoPending: '待處理',
    coworkTodoUntitled: '未命名待辦',
    coworkTodoUnknownStatus: '未知狀態',
    coworkDangerousOperation: '警告：此操作可能會修改檔案或執行系統命令，請仔細檢查。',
    coworkApprove: '允許',
    coworkDeny: '拒絕',
    coworkConfirmSelection: '提交目前選擇',
    coworkDenyRequest: '直接拒絕請求',
    coworkQuestionWizardTitle: '需要您的確認',
    coworkQuestionWizardSkip: '跳過',
    coworkQuestionWizardPrevious: '上一個',
    coworkQuestionWizardNext: '下一個',
    coworkQuestionWizardSubmit: '提交',
    coworkQuestionWizardOther: '其他',
    coworkQuestionWizardOtherPlaceholder: '請輸入自訂答案...',
    coworkQuestionWizardSelectAtLeastOne: '請至少選擇一個選項',
    coworkQuestionWizardAnswerRequired: '請選擇或輸入答案',
    coworkWelcome: '開始協作',
    coworkDescription: '7×24 小時幫你幹活的全場景個人助理 Agent',
    coworkNewSession: '新工作階段',
    coworkContinuePlaceholder: '繼續對話...',
    updateAvailablePill: '有新版本',
    updateAvailableTitle: '檢測到新版本',
    updateAvailableMessage: '檢測到新版本，請前往官網下載並覆蓋安裝。',
    updateAvailableConfirm: '立即更新',
    updateAvailableCancel: '取消',
    updateOpenFailed: '開啟下載頁面失敗',
    updateDownloading: '正在下載更新...',
    updateDownloadCancel: '取消下載',
    updateInstalling: '正在安裝更新，請稍候...',
    updateInstallingHint: '安裝完成後應用將自動重啟',
    updateDownloadFailed: '下載失敗',
    updateInstallFailed: '安裝失敗',
    updateRetry: '重試',
    checkForUpdate: '檢查更新',
    updateChecking: '檢查中...',
    updateUpToDate: '已是最新版本',
    updateCheckFailed: '檢查失敗',
    coworkStartingSession: '正在啟動工作階段...',
    coworkPreparingEnvironment: '準備環境中，請稍候',
    coworkAddFile: '新增檔案',
    coworkDropFileHint: '拖曳檔案到此處，或直接貼上檔案',
    coworkAddImage: '新增圖片',
    coworkInputFileLabel: '輸入檔案',
    imageNotSupportedByModel: '目前模型可能不支援圖片輸入。圖片仍會傳送，但模型可能無法分析。',
    coworkAttachmentRemove: '移除',
    coworkShareSession: '分享',
    coworkExportImageInProgress: '正在匯出圖片...',
    coworkExportImageSuccess: '圖片匯出成功',
    coworkExportImageFailed: '匯出圖片失敗',
    deleteSession: '刪除任務',
    deleteTaskConfirmTitle: '確認刪除任務',
    deleteTaskConfirmMessage: '此操作無法撤銷，任務的所有訊息記錄將被永久刪除。',
    batchOperations: '批次操作',
    batchSelectAll: '全選',
    batchDelete: '刪除',
    batchCancel: '取消',
    batchDeleteConfirmTitle: '確認批次刪除',
    batchDeleteConfirmMessage: '確定要刪除選中的 {count} 個任務嗎？此操作不可撤銷。',
    back: '返回',
    browse: '瀏覽',
    addFolder: '新增資料夾',
    recentFolders: '最近使用',
    noFolderSelected: '未選擇資料夾',
    coworkSelectFolderFirst: '請選擇任務目錄後再提交',
    noRecentFolders: '暫無最近資料夾',
    coworkOpenFolder: '開啟資料夾',
    skills: '技能',
    flows: '流程',
    searchSkills: '搜尋技能',
    manageSkills: '管理技能',
    officialSkills: '官方技能',
    addSkill: '新增',
    uploadSkillZip: '上傳 .zip',
    uploadSkillFolder: '上傳資料夾',
    importFromGithub: '從 GitHub 匯入',
    githubImportTitle: '從 GitHub 匯入',
    githubImportDescription: '支援儲存庫連結與子目錄連結；若儲存庫內有多個技能，將自動全部匯入。',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: '例如：owner/repo 或 GitHub tree/blob 連結',
    githubImportExamples: '範例：owner/repo；https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: '匯入',
    importingSkill: '匯入中...',
    official: '官方',
    noSkillsAvailable: '暫無可用技能',
    skillsDescription: '為您的智慧代理提供預封裝且可重複的最佳實踐與工具',
    skillInstalled: '已安裝',
    skillMarketplace: '技能市場',
    skillMarketplaceEmpty: '暫無可用技能',
    skillCategoryAll: '全部',
    skillInstall: '安裝',
    skillInstalling: '安裝中',
    skillInstallFailed: '安裝失敗',
    skillAlreadyInstalled: '已安裝',
    skillDetailVersion: '版本',
    skillDetailSource: '來源',
    skillDetailAuthor: '作者',
    skillsRoot: '技能目錄',
    skillSourcePlaceholder: 'Git URL 或本地路徑',
    downloadSkill: '下載技能',
    downloadingSkill: '正在下載...',
    deleteSkill: '刪除技能',
    skillDeleteConfirm: '確定刪除技能「{name}」嗎？',
    skillDeleteFailed: '刪除技能失敗',
    skillBuiltInCannotDelete: '系統內建技能不允許刪除',
    skillDownloadFailed: '下載技能失敗',
    skillUpdateFailed: '更新技能失敗',
    activeSkill: '目前技能',
    clearSkill: '清除技能',
    clearAll: '全部清除',
    clearAllSkills: '清除所有已選技能',
    mcpServers: 'MCP',
    mcpDescription: '設定和管理 MCP（Model Context Protocol）伺服器，為您的智慧代理擴充工具能力',
    searchMcpServers: '搜尋 MCP 服務',
    addMcpServer: '自訂',
    editMcpServer: '編輯 MCP 服務',
    deleteMcpServer: '刪除 MCP 服務',
    mcpServerName: '服務名稱',
    mcpServerNamePlaceholder: '輸入服務名稱',
    mcpServerDescription: '描述',
    mcpServerDescriptionPlaceholder: '描述此 MCP 服務的用途',
    mcpTransportType: '傳輸類型',
    mcpCommand: '命令',
    mcpCommandPlaceholder: '例如: node, npx, uvx, python',
    mcpArgs: '參數',
    mcpArgsPlaceholder: '每行一個參數',
    mcpEnvVars: '環境變數',
    mcpUrl: 'URL',
    mcpUrlPlaceholder: '例如: http://localhost:3000/mcp',
    mcpHeaders: 'HTTP 請求標頭',
    mcpHeaderKey: '鍵',
    mcpHeaderValue: '值',
    noMcpServersAvailable: '暫無 MCP 服務',
    mcpDeleteConfirm: '確定刪除 MCP 服務"{name}"嗎？',
    mcpDeleteFailed: '刪除 MCP 服務失敗',
    mcpCreateFailed: '建立 MCP 服務失敗',
    mcpUpdateFailed: '更新 MCP 服務失敗',
    mcpNameRequired: '請填寫服務名稱',
    mcpCommandRequired: 'stdio 類型需要填寫命令',
    mcpUrlRequired: 'SSE/HTTP 類型需要填寫 URL',
    mcpNameExists: '服務名稱已存在',
    mcpTransportStdio: '標準輸入輸出 (stdio)',
    mcpTransportSse: '伺服器推送事件 (SSE)',
    mcpTransportHttp: 'HTTP 串流傳輸',
    addKeyValue: '新增',
    saveMcpServer: '儲存',
    mcpInstalled: '已安裝',
    mcpMarketplace: '市場',
    mcpCustom: '自訂',
    mcpCustomDescription: '手動設定 MCP 伺服器',
    mcpResetForm: '重設',
    mcpInstall: '安裝',
    mcpInstallFromUrl: '透過 URL 安裝',
    mcpInstallFromUrlTitle: '透過 URL 安裝 MCP',
    mcpInstallFromUrlPlaceholder: '輸入 npm 套件名稱或 URL',
    mcpInstallFromUrlHint: '支援 npm 套件名稱（如 @modelcontextprotocol/server-filesystem）、npx 命令或 HTTP/HTTPS URL',
    mcpRequiredConfig: '必填設定',
    mcpOptionalConfig: '可選設定',
    mcpViewOnGithub: '在 GitHub 上檢視',
    mcpNoInstalledServers: '尚未安裝任何 MCP 服務',
    mcpCategoryAll: '全部',
    mcpCategorySearch: '搜尋',
    mcpCategoryBrowser: '瀏覽器',
    mcpCategoryDeveloper: '開發工具',
    mcpCategoryProductivity: '效率工具',
    mcpCategoryDesign: '設計',
    mcpCategoryDataApi: '資料 & API',
    mcpDesc_tavily: '即時網頁搜尋、智慧資料提取和網站爬取',
    mcpDesc_github: 'GitHub 平台整合：儲存庫、Issues、PR、Actions 管理',
    mcpDesc_gitlab: 'GitLab API 整合：專案管理、合併請求、流水線',
    mcpDesc_context7: '為 AI 程式設計提供最新的套件文件和程式碼範例',
    mcpDesc_google_drive: 'Google Drive 檔案存取和搜尋，自動匯出 Workspace 檔案',
    mcpDesc_gmail: 'Gmail 郵件管理：讀取、傳送、搜尋郵件，支援自動認證',
    mcpDesc_google_calendar: 'Google Calendar 行程管理：建立、查詢、更新日曆事件',
    mcpDesc_notion: 'Notion API：搜尋、建立/更新頁面、管理資料庫',
    mcpDesc_slack: 'Slack 工作區：頻道管理、訊息傳送、使用者查詢',
    mcpDesc_todoist: '任務管理：建立、更新、完成和組織待辦事項',
    mcpDesc_playwright: '進階瀏覽器自動化，支援 Chromium/Firefox/WebKit',
    mcpDesc_canva: 'Canva 設計平台：建立和管理設計、範本操作',
    mcpDesc_firecrawl: '網頁抓取與資料提取：支援批次處理、結構化提取和內容分析',
    mcpDesc_fetch: '網頁內容抓取和 HTML 轉 Markdown，適合 LLM 消費',
    emailTab: '信箱',
    emailConfig: '信箱設定',
    emailProvider: '信箱服務商',
    emailSelectProvider: '請選擇信箱服務商',
    emailCustomProvider: '自訂',
    emailAddress: '信箱地址',
    emailPassword: '密碼 / 授權碼',
    emailPasswordPlaceholder: '密碼或應用專用密碼',
    emailAdvancedSettings: '進階設定',
    emailMailbox: '預設收件匣',
    emailConfigSaved: '信箱設定已儲存',
    emailConfigError: '儲存設定失敗',
    emailHintGmail: '如果開啟了兩步驗證，請使用應用專用密碼（App Password）',
    emailHint163: '請使用授權碼，而非帳號密碼。需先在網頁端設定中開啟 IMAP/SMTP 服務',
    emailHintQQ: '請使用授權碼，而非帳號密碼。需先在網頁端設定中開啟 IMAP/SMTP 服務',
    openFile: '開啟檔案',
    openFolder: '開啟資料夾',
    showInFolder: '在資料夾中顯示',
    outputFiles: '輸出檔案',
    openFileFailed: '開啟檔案失敗',
    fileCreated: '檔案已建立',
    imBot: 'IM 機器人',
    dingtalk: '釘釘',
    feishu: '飛書',
    qq: 'QQ',
    telegram: 'Telegram',
    discord: 'Discord',
    nim: '雲信',
    xiaomifeng: '小蜜蜂',
    wecom: '企業微信',
    connected: '已連線',
    disconnected: '未連線',
    kickedByOtherClient: '帳號已在其它地方登入',
    starting: '啟動中',
    start: '啟動',
    stop: '停止',
    messageType: '訊息類型',
    domain: '網域',
    feishuChina: '飛書（中國）',
    renderMode: '渲染模式',
    textMode: '文字',
    cardMode: '卡片',
    chatSettings: '對話設定',
    enableSkills: '啟用技能',
    systemPrompt: '系統提示詞',
    systemPromptPlaceholder: '為 IM 機器人設定自訂指令...',
    saveConfig: '儲存設定',
    imConnectivitySectionTitle: '連通性診斷',
    imConnectivityTest: '測試連通性',
    imConnectivityRetest: '重新測試',
    imConnectivityTesting: '測試中...',
    imConnectivityNoResult: '尚未執行診斷。建議啟用後立即測試。',
    imConnectivityLastChecked: '最近測試',
    imConnectivitySuggestion: '建議',
    imConnectivityVerdict_pass: '可對話',
    imConnectivityVerdict_warn: '需關注',
    imConnectivityVerdict_fail: '不可用',
    imConnectivityCheckTitle_missing_credentials: '設定項缺失',
    imConnectivityCheckTitle_auth_check: '憑證鑑權',
    imConnectivityCheckTitle_gateway_running: 'IM 渠道啟用狀態',
    imConnectivityCheckTitle_inbound_activity: '入站訊息活動',
    imConnectivityCheckTitle_outbound_activity: '出站訊息活動',
    imConnectivityCheckTitle_platform_last_error: '平台最近錯誤',
    imConnectivityCheckTitle_feishu_group_requires_mention: '飛書群聊觸發規則',
    imConnectivityCheckTitle_feishu_event_subscription_required: '飛書事件訂閱要求',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord 群聊觸發規則',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: '釘釘會話權限',
    imConnectivityCheckTitle_nim_p2p_only_hint: '雲信私聊模式',
    imConnectivityCheckSuggestion_missing_credentials: '補齊必填設定項後重試。',
    imConnectivityCheckSuggestion_auth_check: '核對平台憑證、應用權限和發布狀態。',
    imConnectivityCheckSuggestion_gateway_running: '若顯示未啟用，請點擊對應 IM 渠道膠囊按鈕啟用；啟用後確認網路可存取平台服務。',
    imConnectivityCheckSuggestion_inbound_activity: '向機器人發一條測試訊息；群聊場景請 @機器人。',
    imConnectivityCheckSuggestion_outbound_activity: '檢查機器人發訊息權限、可見範圍和會話回包權限。',
    imConnectivityCheckSuggestion_platform_last_error: '根據錯誤提示修復後再重測。',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: '在群聊中使用 @機器人 + 內容。',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: '在飛書後台開啟 im.message.receive_v1 並發布版本。',
    imConnectivityCheckSuggestion_discord_group_requires_mention: '在頻道中使用 @機器人 + 內容。',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: '在 @BotFather 調整 Privacy Mode 設定。',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: '確認機器人已加入目標會話並允許收發訊息。',
    imConnectivityCheckSuggestion_nim_p2p_only_hint: '透過私聊方式向機器人帳號發送訊息。',
    nimAccountPlaceholder: '機器人帳號ID',
    nimAccountHint: '在雲信控制台「帳號管理」中建立的 IM 帳號 ID',
    nimCredentialsGuide: '如何取得雲信憑證：',
    nimGuideStep1: '登入網易雲信控制台（yunxin.163.com）',
    nimGuideStep2: '建立或選擇應用，取得 App Key',
    nimGuideStep3: '在「帳號數-子功能設定」中建立 IM 帳號（accid）',
    nimGuideStep4: '為該帳號產生 Token（密碼）- 建議長期有效',
    nimAppKeyHint: '從雲信控制台應用資訊中取得',
    nimTokenHint: '為該帳號產生的存取憑證（建議設定為長期有效）',
    nimAccountWhitelist: '白名單帳號',
    nimAccountWhitelistHint: '填寫允許與機器人對話的雲信帳號，多個帳號用逗號分隔。留空則不限制，回應所有帳號的訊息。',
    nimTeamPolicy: '群訊息策略',
    nimTeamPolicyDisabled: '停用 - 不回應群訊息',
    nimTeamPolicyOpen: '開放 - 回應所有群的@訊息',
    nimTeamPolicyAllowlist: '白名單 - 僅回應指定群的@訊息',
    nimTeamPolicyHint: '群訊息僅回應@機器人的訊息',
    nimTeamAllowlist: '群白名單',
    nimTeamAllowlistHint: '填寫允許回應的群ID，多個用逗號分隔',
    nimQChatEnabled: '啟用圈組 (QChat)',
    nimQChatEnabledHint: '訂閱圈組訊息，僅回應@機器人的訊息',
    nimQChatServerIds: '圈組伺服器 ID',
    nimQChatServerIdsPlaceholder: '留空自動發現所有已加入的伺服器',
    nimQChatServerIdsHint: '指定要訂閱的伺服器 ID，多個用逗號分隔。留空則自動訂閱所有已加入的伺服器。',
    xiaomifengClientIdPlaceholder: '小蜜蜂助理Client ID',
    autoLaunch: '開機自啟動',
    autoLaunchDescription: '系統啟動時自動執行應用',
    useSystemProxy: '使用系統代理',
    useSystemProxyDescription: '開啟後網路請求將跟隨系統代理（儲存後生效）',
    scheduledTasks: '定時任務',
    scheduledTasksTitle: '定時任務',
    scheduledTasksNewTask: '新建任務',
    scheduledTasksEmptyState: '暫無定時任務',
    scheduledTasksEmptyHint: '建立定時任務，讓 AI 按計劃自動執行',
    taskManager: '記錄助理',
    taskManagerTitle: '任務管理',
    taskManagerNewTask: '新建任務',
    taskManagerEmptyState: '暫無任務',
    taskManagerEmptyHint: '建立任務或從聊天中提取任務',
    taskManagerListColTitle: '標題',
    calendar: '日曆',
    list: '列表',
    chat: '聊天',
    scheduledTasksListColSchedule: '計劃於',
    scheduledTasksListColStatus: '狀態',
    scheduledTasksListColMore: '更多',
    scheduledTasksTabTasks: '任務',
    scheduledTasksTabHistory: '歷史',
    scheduledTasksHistoryEmpty: '暫無執行記錄',
    scheduledTasksHistoryColTitle: '標題',
    scheduledTasksHistoryColTime: '執行時間',
    scheduledTasksHistoryColStatus: '狀態',
    scheduledTasksFormName: '標題',
    scheduledTasksFormNamePlaceholder: '輸入任務標題',
    scheduledTasksFormDescription: '描述',
    scheduledTasksFormDescriptionPlaceholder: '可選的任務描述',
    scheduledTasksFormScheduleType: '計劃',
    scheduledTasksFormScheduleModeOnce: '不重複',
    scheduledTasksFormScheduleModeDaily: '每天',
    scheduledTasksFormScheduleModeWeekly: '每週',
    scheduledTasksFormScheduleModeMonthly: '每月',
    scheduledTasksFormWeekSun: '週日',
    scheduledTasksFormWeekMon: '週一',
    scheduledTasksFormWeekTue: '週二',
    scheduledTasksFormWeekWed: '週三',
    scheduledTasksFormWeekThu: '週四',
    scheduledTasksFormWeekFri: '週五',
    scheduledTasksFormWeekSat: '週六',
    scheduledTasksFormValidationTimeRequired: '請選擇時間',
    scheduledTasksFormValidationWorkingDirectoryRequired: '請選擇任務工作目錄',
    scheduledTasksFormMonthDaySuffix: '日',
    scheduledTasksFormScheduleAt: '定時執行',
    scheduledTasksFormScheduleAtHint: '在指定時間執行一次',
    scheduledTasksFormScheduleInterval: '間隔執行',
    scheduledTasksFormScheduleIntervalHint: '按固定間隔重複執行',
    scheduledTasksFormScheduleCron: 'Cron 運算式',
    scheduledTasksFormScheduleCronHint: '使用 Cron 運算式定義複雜排程',
    scheduledTasksFormDatetime: '執行時間',
    scheduledTasksFormInterval: '間隔時間',
    scheduledTasksFormIntervalMinutes: '分鐘',
    scheduledTasksFormIntervalHours: '小時',
    scheduledTasksFormIntervalDays: '天',
    scheduledTasksFormCronExpression: 'Cron 運算式',
    scheduledTasksFormCronPlaceholder: '例如: */5 * * * * (每5分鐘)',
    scheduledTasksFormCronHelp: '格式: 分 時 日 月 週 (5段)',
    scheduledTasksFormPrompt: '執行提示詞',
    scheduledTasksFormPromptPlaceholder: '輸入要執行的提示詞...',
    scheduledTasksFormWorkingDirectory: '工作目錄',
    scheduledTasksFormWorkingDirectoryPlaceholder: '輸入專案路徑',
    scheduledTasksFormSystemPrompt: '系統提示詞',
    scheduledTasksFormSystemPromptPlaceholder: '可選的系統提示詞...',
    scheduledTasksFormExecutionMode: '執行模式',
    scheduledTasksFormExecutionModeAuto: '自動',
    scheduledTasksFormExecutionModeLocal: '本地',
    scheduledTasksFormExecutionModeSandbox: '沙箱',
    scheduledTasksFormEnabled: '啟用任務',
    scheduledTasksFormCreate: '建立任務',
    scheduledTasksFormUpdate: '更新任務',
    scheduledTasksFormValidationNameRequired: '請輸入任務標題',
    scheduledTasksFormValidationPromptRequired: '請輸入執行提示詞',
    scheduledTasksFormValidationDatetimeFuture: '執行時間必須在未來',
    scheduledTasksFormValidationIntervalPositive: '間隔時間必須大於 0',
    scheduledTasksFormValidationCronRequired: '請輸入 Cron 運算式',
    scheduledTasksEdit: '編輯',
    scheduledTasksDelete: '刪除',
    scheduledTasksDeleteConfirm: '確定要刪除任務「{name}」嗎？此操作不可撤銷。',
    scheduledTasksRun: '立即執行',
    scheduledTasksStop: '停止',
    scheduledTasksEnabled: '已啟用',
    scheduledTasksDisabled: '已停用',
    scheduledTasksDetail: '任務詳情',
    scheduledTasksConfiguration: '設定資訊',
    scheduledTasksSchedule: '計劃',
    scheduledTasksPrompt: '提示詞',
    scheduledTasksWorkingDirectory: '工作目錄',
    scheduledTasksSystemPrompt: '系統提示詞',
    scheduledTasksExecutionMode: '執行模式',
    scheduledTasksStatus: '執行狀態',
    scheduledTasksNextRun: '下次執行',
    scheduledTasksLastRun: '上次執行',
    scheduledTasksLastDuration: '上次耗時',
    scheduledTasksLastError: '最近錯誤',
    scheduledTasksConsecutiveErrors: '連續錯誤',
    scheduledTasksRunHistory: '執行歷史',
    scheduledTasksNoRuns: '暫無執行記錄',
    scheduledTasksLoadMore: '載入更多',
    scheduledTasksManual: '手動',
    scheduledTasksScheduled: '定時',
    scheduledTasksViewSession: '檢視工作階段',
    scheduledTasksStatusSuccess: '成功',
    scheduledTasksStatusError: '失敗',
    scheduledTasksStatusRunning: '執行中',
    scheduledTasksStatusIdle: '閒置',
    scheduledTasksNotSet: '未設定',
    scheduledTasksNone: '無',
    scheduledTasksScheduleAtLabel: '定時',
    scheduledTasksScheduleIntervalLabel: '間隔',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: '每',
    scheduledTasksAutoDisabledErrors: '連續錯誤過多，任務已自動停用',
    scheduledTasksCreateFailed: '建立任務失敗',
    scheduledTasksUpdateFailed: '更新任務失敗',
    scheduledTasksDeleteFailed: '刪除任務失敗',
    scheduledTasksRunFailed: '執行任務失敗',
    scheduledTasksStopFailed: '停止任務失敗',
    scheduledTasksFormExpiresAt: '到期時間',
    scheduledTasksFormOptional: '（可選）',
    scheduledTasksFormExpiresAtHint: '可選，到期後任務不再執行',
    scheduledTasksFormExpiresAtClear: '清除',
    scheduledTasksFormExpiresAtNone: '永不過期',
    scheduledTasksDetailExpiresAt: '到期時間',
    scheduledTasksFormNotify: 'IM 通知',
    scheduledTasksFormNotifyHint: '可選，任務完成後透過 IM 傳送結果通知',
    scheduledTasksFormNotifyDingtalk: '釘釘',
    scheduledTasksFormNotifyFeishu: '飛書',
    scheduledTasksFormNotifyQq: 'QQ',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNim: '雲信',
    scheduledTasksFormNotifyXiaomifeng: '小蜜蜂',
    scheduledTasksFormNotifyWecom: '企業微信',
    scheduledTasksFormNotifyNone: '無',
    scheduledTasksFormNotifyNotConfigured: '未設定',
    scheduledTasksDetailNotify: '通知',
    scheduledTasksToggleWarningAtPast: '該任務的執行時間已過，啟用後將不會執行',
    scheduledTasksToggleWarningExpired: '該任務已過期，啟用後將不會執行',
  },
  en: {
    // Sequence Detect
    manageContacts: 'Manage',
    alertContacts: 'Alert Contacts',
    alertContactsTitle: 'Alert Contacts',
    alertContactsDesc: 'The following contacts will be notified when alert sequence is detected.',

    // Common
    save: 'Save',
    cancel: 'Cancel',
    saving: 'Saving...',
    create: 'Create',
    delete: 'Delete',
    optional: 'optional',
    user: 'User',
    login: 'Login',
    inDevelopment: 'In development',
    
    // Settings
    settings: 'Settings',
    general: 'General',
    model: 'Model',
    shortcuts: 'Shortcuts',
    about: 'About',
    aboutVersion: 'Version',
    aboutContactEmail: 'Contact Email',
    aboutUserManual: 'User Manual',
    aboutServiceTerms: 'Terms of Service',
    aboutExportLogs: 'Export Logs',
    aboutExportingLogs: 'Exporting...',
    aboutExportLogsFailed: 'Failed to export logs',
    aboutExportLogsSuccess: 'Logs exported successfully',
    aboutExportLogsPartial: 'Logs exported (missing logs were filled as empty files)',
    testMode: 'Test Mode',
    theme: 'Theme',
    appearance: 'Appearance',
    language: 'Language',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    chinese: 'Chinese',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    
    // API Settings
    apiKey: 'API Key',
    apiKeyPlaceholder: 'Enter your API Key',
    baseUrl: 'API Base URL',
    baseUrlPlaceholder: 'Enter API Base URL',
    baseUrlHint1: 'Usually just the domain, path will be appended automatically',
    baseUrlHintExample1: 'https://api.siliconflow.cn',
    baseUrlHint2: 'For non-standard APIs, enter the full URL',
    baseUrlHintExample2: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
    currentModel: 'Current Model',
    availableModels: 'Available Models',
    modelSwitchHint: 'You can switch models in the chat interface',
    
    // Model Provider Settings
    enabled: 'Enabled',
    disabled: 'Disabled',
    providerStatusOn: 'on',
    providerStatusOff: 'off',
    providerSettings: 'Provider Settings',
    modelProviders: 'Model Providers',
    projectConnections: 'Project Connections',
    integrationProjects: 'Connected Projects',
    integrationAddProject: 'Add',
    integrationNewProject: 'New Project Connection',
    integrationDescription: 'Connect any project that publishes an OpenAPI 3.x document and control which operations AI may use.',
    integrationProjectName: 'Project Name',
    integrationAuthType: 'Authentication',
    integrationAuthNone: 'No authentication',
    integrationHeaderName: 'API Key Header',
    integrationSecretUnchanged: 'Configured; leave blank to keep unchanged',
    integrationDiscover: 'Discover APIs',
    integrationApiDirectory: 'API Directory',
    integrationOperations: 'operations',
    integrationNoProjects: 'No project connections yet',
    integrationNoEndpoints: 'No operations discovered. Save the project and discover its OpenAPI document.',
    integrationNameRequired: 'Project name is required',
    integrationBaseUrlRequired: 'API Base URL is required',
    integrationSaved: 'Project connection saved',
    integrationSaveFailed: 'Failed to save project connection',
    integrationLoadFailed: 'Failed to load project connections',
    integrationTestFailed: 'Connection test failed',
    integrationDiscoverySuccess: 'Discovered',
    integrationDiscoveryFailed: 'Failed to discover OpenAPI document',
    integrationDeleteConfirm: 'Delete this project connection and its API configuration?',
    integrationDeleteFailed: 'Failed to delete project connection',
    integrationEndpointUpdateFailed: 'Failed to update operation access',
    integrationPolicyDisabled: 'Disabled',
    integrationPolicyManual: 'Manual only',
    integrationPolicyAgentRead: 'Allow AI read',
    integrationPolicyAgentWrite: 'Allow AI write',
    integrationPolicyAutomatic: 'Allow proactive use',
    integrationConnectionEnabled: 'Connection enabled',
    integrationConnectionDisabled: 'Connection disabled',
    integrationAiToolsAuthorized: 'AI tools authorized',
    integrationNoAiTools: 'No operations are authorized for AI',
    integrationAiAuthorizationHint: 'The API key authenticates the connection. Operations must also be authorized before they become AI tools. Authorize write operations individually below.',
    integrationAuthorizeAllReads: 'Authorize all GET',
    integrationAuthorizing: 'Authorizing...',
    integrationReadAuthorizationSuccess: 'Authorized read operations:',
    integrationReadAuthorizationFailed: 'Failed to authorize read operations',
    demoIntegrationWarning: '⚠️ Demo mode: Do not connect real production APIs. This feature is for exploration only — any API keys and configurations you enter may be visible to others.',
    addModel: 'Add Model',
    editModel: 'Edit Model',
    addNewModel: 'Add New Model',
    modelName: 'Model Name',
    modelId: 'Model ID',
    modelNameAndIdRequired: 'Model name and model ID are required',
    modelIdExists: 'Model ID already exists. Use a different one',
    ollamaModelName: 'Model Name',
    ollamaModelNameHint: 'Enter the name of a model installed in Ollama, e.g. qwen3:8b, lfm2:latest',
    ollamaModelNamePlaceholder: 'qwen3:8b',
    ollamaDisplayName: 'Display Name (optional)',
    ollamaDisplayNameHint: 'Custom name shown in the model list. Leave empty to use the model name.',
    ollamaDisplayNamePlaceholder: 'My Qwen3 Model',
    ollamaModelNameRequired: 'Model name is required',
    supportsImageInput: 'Supports image input',
    imageInput: 'Image',
    noModelsAvailable: 'No models available',
    addFirstModel: 'Add First Model',
    testConnection: 'Test Connection',
    connectionTestResult: 'Connection Test Result',
    testing: 'Testing...',
    connectionSuccess: 'Connection successful',
    connectionFailed: 'Connection failed',
    noModelsConfigured: 'Please add a model first',
    apiFormat: 'API Format',
    apiFormatNative: 'Anthropic Compatible',
    apiFormatOpenAI: 'OpenAI Compatible',
    apiFormatHint: 'Select protocol compatibility: Anthropic Compatible or OpenAI Compatible',
    zhipuCodingPlanHint: 'When enabled, uses the GLM Coding Plan dedicated API endpoint',
    zhipuCodingPlanEndpointHint: 'When using GLM Coding Plan, the system will automatically switch to the dedicated Coding endpoint',
    qwenCodingPlanHint: 'When enabled, uses the Alibaba Cloud Bailian Coding Plan dedicated API endpoint',
    qwenCodingPlanEndpointHint: 'When using Coding Plan, you need a dedicated API Key (format: sk-sp-xxxxx)',
    volcengineCodingPlanHint: 'When enabled, uses the Volcengine Coding Plan dedicated API endpoint',
    volcengineCodingPlanEndpointHint: 'When using Coding Plan, the system will automatically switch to the dedicated Coding endpoint',
    moonshotCodingPlanHint: 'When enabled, uses the Moonshot Coding Plan dedicated API endpoint',
    moonshotCodingPlanEndpointHint: 'When using Coding Plan, the system will automatically switch to the dedicated Coding endpoint',
    import: 'Import',
    export: 'Export',
    importProvidersFailed: 'Failed to import providers',
    exportProvidersFailed: 'Failed to export providers',
    invalidProvidersFile: 'Invalid providers file',
    decryptProvidersFailed: 'Failed to decrypt API key. Make sure the file was exported on this device.',
    decryptProvidersPartial: 'Some keys could not be decrypted. Existing keys were kept or left blank.',

    // Password related
    password: 'Password',
    confirmPassword: 'Confirm Password',
    enterPassword: 'Enter password',
    enterPasswordAgain: 'Enter password again',
    exportPasswordTitle: 'Set Export Password',
    importPasswordTitle: 'Enter Import Password',
    exportPasswordHint: 'This password encrypts your API keys. Use the same password when importing.',
    importPasswordHint: 'Enter the password you set when exporting',
    passwordRequired: 'Password is required',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 4 characters',
    wrongPassword: 'Wrong password, please try again',
    
    // Shortcuts
    keyboardShortcuts: 'Keyboard Shortcuts',
    newChat: 'New Task',
    search: 'Search Tasks',
    openSettings: 'Open Settings',
    close: 'Close',
    loginNotAvailable: 'Login is not available yet',
    collapse: 'Collapse',
    expand: 'Expand',
    featureInDevelopment: 'In development',
    
    // Error Messages
    failedToLoadSettings: 'Failed to load settings',
    failedToSaveSettings: 'Failed to save settings',
    
    // Loading State
    loading: 'Loading...',
    
    // Sidebar
    conversations: 'Conversations',
    noConversations: 'No conversations',
    createNewChat: 'New Chat',
    deleteConversation: 'Delete Conversation',
    renameConversation: 'Rename',
    moveToProject: 'Move to project',
    pinConversation: 'Pin chat',
    unpinConversation: 'Unpin chat',
    noProject: 'No project',
    noProjects: 'No projects',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this conversation? This action cannot be undone.',
    searchChats: 'Search Chats',
    searchConversations: 'Search tasks...',
    searchNoResults: 'No matching tasks',
    projects: 'Projects',
    yourChats: 'Your Chats',
    createProject: 'New Project',
    projectNamePlaceholder: 'Project name',
    projectColorLabel: 'Color',
    projectIconLabel: 'Icon',
    project: 'Project',
    projectHistory: 'History',
    projectPrompt: 'Prompt',
    projectPromptPlaceholder: 'Add a prompt for this project',
    projectSettings: 'Project settings',
    projectNameLabel: 'Project name',
    deleteProject: 'Delete project',
    confirmDeleteProject: 'Are you sure you want to delete this project? Chats in this project will be moved to your chat list. This action cannot be undone.',
    folderIconDefault: 'Default',
    folderIconHealth: 'Health',
    folderIconStudy: 'Study',
    folderIconMath: 'Math',
    folderIconWork: 'Work',
    folderIconCode: 'Code',
    folderIconIdea: 'Ideas',
    
    // Chat Window
    sendMessage: 'Send Message',
    typeMessage: 'Type a message...',
    quickPrompt: 'Ask anything...',
    regenerateResponse: 'Regenerate Response',
    copyToClipboard: 'Copy to Clipboard',
    messageCopied: 'Message copied',
    clearConversation: 'Clear Conversation',
    confirmClearConversation: 'Are you sure you want to clear the current conversation? This action cannot be undone.',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: 'days ago',
    justNow: 'Just now',
    minutesAgo: 'minutes ago',
    hoursAgo: 'hours ago',
    welcomeMessage: 'How can I help you today?',
    thinking: 'Thinking...',
    reasoning: 'Reasoning',
    editMessage: 'Edit message',
    emptyMessage: 'Empty message',
    artifactOpen: 'Open',
    artifactView: 'View',
    artifactViewing: 'Viewing',
    artifactPreview: 'Preview',
    artifactCode: 'Code',
    imageLimitReached: 'Up to 10 images',
    imageReadError: 'Failed to read image',
    imageInputNotSupported: 'Current model does not support images',
    
    // Model Selection
    selectModel: 'Select Model',
    
    // Error Messages
    errorOccurred: 'An error occurred',
    tryAgain: 'Please try again',
    networkError: 'Network error',
    apiKeyRequired: 'API Key Required',
    configureApiKey: 'Please configure your API key in settings',
    
    // Initialization
    initializationError: 'Failed to initialize application. Please check your configuration.',
    apiKeyNotConfigured: 'API key not configured. Please set up your API key in settings.',

    // MednnectAI
    cowork: '{appName}',
    coworkSandbox: 'Sandbox',
    coworkSettings: 'MednnectAI Settings',
    coworkHistory: 'Task History',
    coworkNoSessions: 'No tasks yet',
    coworkPinSession: 'Pin task',
    coworkUnpinSession: 'Unpin task',
    coworkSessionActions: 'More actions',
    coworkPlaceholder: 'Assign a task or ask any question',
    coworkWorkingDirectory: 'Working Directory',
    coworkWorkingDirectoryPlaceholder: 'Enter project path',
    coworkWorkingDirectoryHint: 'MednnectAI will execute commands in this directory',
    coworkSystemPrompt: 'System Prompt',
    coworkSystemPromptPlaceholder: 'Set custom instructions for MednnectAI...',
    coworkSystemPromptHint: 'Optional system prompt to customize MednnectAI\'s behavior',
    coworkModelSettingsRequired: 'Please configure models and API keys in Model Settings first.',
    coworkModelSettingsTitle: 'Model Settings',
    coworkModelSettingsHint: 'MednnectAI uses the current model and provider configuration from Model Settings.',
    coworkModelSettingsAction: 'Go to Model Settings',
    coworkApiConfigTitle: 'API Configuration',
    coworkApiConfigHint: 'Supports Anthropic-compatible and OpenAI-compatible APIs (OpenAI compatibility is bridged by a local adapter).',
    coworkExecutionMode: 'Execution Mode',
    coworkExecutionModeAuto: 'Auto (prefer sandbox)',
    coworkExecutionModeLocal: 'Local only',
    coworkExecutionModeSandbox: 'Sandbox only (Built-in VM)',
    coworkExecutionModeAutoHint: 'Prefer the built-in VM sandbox when available, otherwise run locally',
    coworkExecutionModeLocalHint: 'Always run on this machine',
    coworkExecutionModeSandboxHint: 'Require the built-in VM sandbox or fail',
    coworkMemoryTitle: 'Memory',
    coworkMemoryEnabled: 'Enable user memories',
    coworkMemoryEnabledHint: 'Inject stable user facts into the <userMemories> prompt block.',
    coworkMemorySimpleHint: 'For most users, keep this on and manage entries below. No extra tuning needed.',
    coworkMemoryLlmJudgeEnabled: 'Enable LLM secondary judge',
    coworkMemoryLlmJudgeEnabledHint: 'Only borderline rule cases are reviewed by the model for better accuracy (adds a small number of API calls).',
    coworkMemoryAutoWrite: 'Auto-write memory',
    coworkMemoryCaptureEachTurn: 'Enable implicit updates',
    coworkMemoryGuardLevel: 'Write guard level',
    coworkMemoryGuardStrict: 'Strict',
    coworkMemoryGuardStandard: 'Standard',
    coworkMemoryGuardRelaxed: 'Relaxed',
    coworkMemoryMaxResults: 'Max injected items',
    coworkMemoryMaxResultsHint: 'Range: 1-60, recommended: 12',
    coworkMemoryMinScore: 'Minimum relevance threshold',
    coworkMemoryMaxInjectChars: 'Max injected characters',
    coworkMemoryRecallInterval: 'Auto recall interval (turns)',
    coworkMemoryRecallIntervalHint: 'Inject memory every N turns, recommended: 3',
    coworkMemoryCrudTitle: 'Managed memory entries',
    coworkMemoryManageHint: 'View, search, add, edit, and delete memory entries here.',
    coworkMemoryTotalLabel: 'Total',
    coworkMemoryActiveLabel: 'Active',
    coworkMemoryInactiveLabel: 'Inactive',
    coworkMemoryStatusActive: 'Active',
    coworkMemoryStatusInactive: 'Inactive',
    coworkMemoryStatusDeleted: 'Deleted',
    coworkMemoryUpdatedAt: 'Updated',
    coworkMemoryEditingTag: 'Editing selected memory',
    coworkMemoryRebuildIndex: 'Rebuild index',
    coworkMemoryRebuildSuccess: 'Memory index rebuilt',
    coworkMemoryRebuildFailed: 'Failed to rebuild memory index',
    coworkMemoryStatsSummary: 'Managed entries',
    coworkMemorySearchPlaceholder: 'Search memory text/source',
    coworkMemoryCategoryAll: 'All categories',
    coworkMemoryEmpty: 'No memory entries yet',
    coworkMemoryCrudTextPlaceholder: 'Enter memory text',
    coworkMemoryCrudCreate: 'Create entry',
    coworkMemoryCrudUpdate: 'Update entry',
    coworkMemoryCrudSaveFailed: 'Failed to save memory entry',
    coworkMemoryCrudDeleteFailed: 'Failed to delete memory entry',
    coworkMemoryAdvancedShow: 'Show advanced settings',
    coworkMemoryAdvancedHide: 'Hide advanced settings',
    coworkMemoryEmbeddingEnabled: 'Enable local embedding rerank',
    coworkMemoryEmbeddingEnabledHint: 'Rerank lexical hits with local vector similarity for better recall quality',
    coworkMemoryEmbeddingModel: 'Embedding model',
    coworkMemoryEmbeddingModelHint: 'Recommended: BAAI/bge-m3. You can switch to any downloaded sentence-transformers model',
    coworkMemoryEmbeddingLocalModelPath: 'Local model path (optional)',
    coworkMemoryEmbeddingLocalModelPathHint: 'If set, load model from this directory first; if empty, load by model id',
    coworkMemoryEmbeddingAutoDownload: 'Allow auto model download',
    coworkMemoryEmbeddingAutoDownloadHint: 'When disabled, you must provide a local model path',
    coworkMemoryEmbeddingDownload: 'Download / Validate model',
    coworkMemoryEmbeddingDownloading: 'Downloading...',
    coworkMemoryEmbeddingDownloadHint: 'Manually trigger model download (or validate local path). This can take a while, wait for progress to finish',
    coworkMemoryEmbeddingDownloadSuccess: 'Embedding model is ready',
    coworkMemoryEmbeddingDownloadFailed: 'Failed to download embedding model',
    coworkMemoryEmbeddingProgressPreparing: 'Preparing download task',
    coworkMemoryEmbeddingProgressInit: 'Initializing',
    coworkMemoryEmbeddingProgressDownload: 'Downloading model files',
    coworkMemoryEmbeddingProgressLoad: 'Loading model',
    coworkMemoryEmbeddingProgressEncode: 'Warming up model',
    coworkMemoryEmbeddingProgressDone: 'Completed',
    coworkMemoryEmbeddingProgressError: 'Failed',
    coworkMemoryEmbeddingWeight: 'Semantic rerank weight',
    coworkMemoryEmbeddingWeightHint: 'Range 0-1. Higher means more embedding influence. Recommended: 0.62',
    coworkSandboxManualInstallNotice: 'You are currently running outside Sandbox mode. Install sandbox components manually to enable sandbox execution.',
    coworkSandboxManualInstallAction: 'Open Sandbox Settings',
    coworkSandboxChecking: 'Checking built-in VM sandbox...',
    coworkSandboxUnsupported: 'Built-in VM sandbox is not supported on this system',
    coworkSandboxRuntimeMissing: 'Sandbox runtime not found',
    coworkSandboxImageMissing: 'Sandbox image not found',
    coworkSandboxDownloading: 'Downloading sandbox components...',
    coworkSandboxInstall: 'Install Sandbox',
    coworkSandboxInstalling: 'Installing...',
    coworkSandboxSelectionBlocked: 'Sandbox unavailable. Please choose Auto or Local.',
    coworkSandboxBadge: 'Sandbox',
    coworkLocalBadge: 'Local',
    coworkApiProviderModel: 'Select from provider models',
    coworkApiProviderModelCustom: 'Custom',
    coworkApiProviderModelHint: 'Only shows enabled providers with configured API key and base URL.',
    coworkApiBaseUrl: 'API Base URL',
    coworkApiKey: 'API Key',
    coworkApiModel: 'Model Name',
    coworkApiKeyRequired: 'API key is required',
    coworkApiBaseUrlRequired: 'Base URL is required',
    coworkApiModelRequired: 'Model name is required',
    coworkApiBaseUrlInvalid: 'Invalid Base URL format',
    coworkApiConfigSaveFailed: 'Failed to save API configuration',
    coworkApiConfigLoadFailed: 'Failed to load API configuration',
    coworkStatusIdle: 'Idle',
    coworkStatusRunning: 'Running',
    coworkStatusCompleted: 'Completed',
    coworkStatusError: 'Error',
    coworkPermissionRequired: 'Permission Required',
    coworkPermissionDescription: 'MednnectAI is requesting to perform the following action',
    coworkToolName: 'Tool Name',
    coworkToolInput: 'Tool Input',
    coworkToolResult: 'Result',
    coworkToolRunning: 'Running...',
    coworkTodosTitle: 'Todos',
    coworkTodoItems: 'items',
    coworkTodoCompleted: 'completed',
    coworkTodoInProgress: 'in progress',
    coworkTodoPending: 'pending',
    coworkTodoUntitled: 'Untitled todo',
    coworkTodoUnknownStatus: 'Unknown status',
    coworkDangerousOperation: 'Warning: This operation may modify files or execute system commands. Please review carefully.',
    coworkApprove: 'Approve',
    coworkDeny: 'Deny',
    coworkConfirmSelection: 'Submit selection',
    coworkDenyRequest: 'Deny request',
    coworkQuestionWizardTitle: 'Confirmation Needed',
    coworkQuestionWizardSkip: 'Skip',
    coworkQuestionWizardPrevious: 'Previous',
    coworkQuestionWizardNext: 'Next',
    coworkQuestionWizardSubmit: 'Submit',
    coworkQuestionWizardOther: 'Other',
    coworkQuestionWizardOtherPlaceholder: 'Enter custom answer...',
    coworkQuestionWizardSelectAtLeastOne: 'Please select at least one option',
    coworkQuestionWizardAnswerRequired: 'Please select or enter an answer',
    coworkWelcome: 'Start Collaborating',
    coworkDescription: 'A 24/7 personal assistant agent that gets work done for you',
    coworkNewSession: 'New Session',
    coworkContinuePlaceholder: 'Continue the conversation...',
    updateAvailablePill: 'New update',
    updateAvailableTitle: 'New version available',
    updateAvailableMessage: 'A new version is available. Please download it from the official website and install over the current version.',
    updateAvailableConfirm: 'Update Now',
    updateAvailableCancel: 'Cancel',
    updateOpenFailed: 'Failed to open download page',
    updateDownloading: 'Downloading update...',
    updateDownloadCancel: 'Cancel Download',
    updateInstalling: 'Installing update, please wait...',
    updateInstallingHint: 'The app will restart automatically after installation',
    updateDownloadFailed: 'Download failed',
    updateInstallFailed: 'Installation failed',
    updateRetry: 'Retry',
    checkForUpdate: 'Check for Updates',
    updateChecking: 'Checking...',
    updateUpToDate: 'Up to date',
    updateCheckFailed: 'Check failed',
    coworkStartingSession: 'Starting session...',
    coworkPreparingEnvironment: 'Preparing environment, please wait',
    coworkAddFile: 'Add File',
    coworkDropFileHint: 'Drop files here, or paste files directly',
    coworkAddImage: 'Add Image',
    coworkInputFileLabel: 'Input file',
    imageNotSupportedByModel: 'The selected model may not support image input. The image will still be sent, but the model might not be able to analyze it.',
    coworkAttachmentRemove: 'Remove',
    coworkShareSession: 'Share',
    coworkExportImageInProgress: 'Exporting image...',
    coworkExportImageSuccess: 'Image exported successfully',
    coworkExportImageFailed: 'Failed to export image',
    deleteSession: 'Delete Task',
    deleteTaskConfirmTitle: 'Confirm Deletion',
    deleteTaskConfirmMessage: 'This action cannot be undone. All messages in this task will be permanently deleted.',
    batchOperations: 'Batch Operations',
    batchSelectAll: 'Select All',
    batchDelete: 'Delete',
    batchCancel: 'Cancel',
    batchDeleteConfirmTitle: 'Confirm Batch Deletion',
    batchDeleteConfirmMessage: 'Are you sure you want to delete {count} selected tasks? This action cannot be undone.',
    back: 'Back',
    sequenceDetect: 'Sequence Detect',
    browse: 'Browse',
    addFolder: 'Add Folder',
    recentFolders: 'Recent Folders',
    noFolderSelected: 'No folder selected',
    coworkSelectFolderFirst: 'Please select a task folder before submitting',
    noRecentFolders: 'No recent folders',
    coworkOpenFolder: 'Open folder',

    // Skills
    skills: 'Skills',
      flows: 'Flows',
    searchSkills: 'Search skills',
    manageSkills: 'Manage Skills',
    officialSkills: 'Official Skills',
    addSkill: 'Add',
    uploadSkillZip: 'Upload .zip',
    uploadSkillFolder: 'Upload folder',
    importFromGithub: 'Import from GitHub',
    githubImportTitle: 'Import from GitHub',
    githubImportDescription: 'Supports both repository and subdirectory links. If a repo contains multiple skills, all will be imported.',
    githubImportUrlLabel: 'URL',
    githubSkillPlaceholder: 'e.g. owner/repo or a GitHub tree/blob URL',
    githubImportExamples: 'Examples: owner/repo; https://github.com/owner/repo/tree/main/SKILLs/my-skill',
    importSkill: 'Import',
    importingSkill: 'Importing...',
    official: 'Official',
    noSkillsAvailable: 'No skills available',
    skillsDescription: 'Pre-packaged best practices and tools for your AI agent',
    skillInstalled: 'Installed',
    skillMarketplace: 'Marketplace',
    skillMarketplaceEmpty: 'No skills available yet',
    skillCategoryAll: 'All',
    skillInstall: 'Install',
    skillInstalling: 'Installing',
    skillInstallFailed: 'Install failed',
    skillAlreadyInstalled: 'Installed',
    skillDetailVersion: 'Version',
    skillDetailSource: 'Source',
    skillDetailAuthor: 'Author',
    skillsRoot: 'Skills folder',
    skillSourcePlaceholder: 'Git URL or local path',
    downloadSkill: 'Download Skill',
    downloadingSkill: 'Downloading...',
    deleteSkill: 'Delete Skill',
    skillDeleteConfirm: 'Delete skill \"{name}\"?',
    skillDeleteFailed: 'Failed to delete skill',
    skillBuiltInCannotDelete: 'Built-in skills cannot be deleted',
    skillDownloadFailed: 'Failed to download skill',
    skillUpdateFailed: 'Failed to update skill',
    activeSkill: 'Active Skill',
    clearSkill: 'Clear Skill',
    clearAll: 'Clear All',
    clearAllSkills: 'Clear all selected skills',

    // MCP Servers
    mcpServers: 'MCP',
    mcpDescription: 'Configure and manage MCP (Model Context Protocol) servers to extend your agent\'s tool capabilities',
    searchMcpServers: 'Search MCP servers',
    addMcpServer: 'Custom',
    editMcpServer: 'Edit MCP Server',
    deleteMcpServer: 'Delete MCP Server',
    mcpServerName: 'Server Name',
    mcpServerNamePlaceholder: 'Enter server name',
    mcpServerDescription: 'Description',
    mcpServerDescriptionPlaceholder: 'Describe what this MCP server does',
    mcpTransportType: 'Transport Type',
    mcpCommand: 'Command',
    mcpCommandPlaceholder: 'e.g. node, npx, uvx, python',
    mcpArgs: 'Arguments',
    mcpArgsPlaceholder: 'One argument per line',
    mcpEnvVars: 'Environment Variables',
    mcpUrl: 'URL',
    mcpUrlPlaceholder: 'e.g. http://localhost:3000/mcp',
    mcpHeaders: 'HTTP Headers',
    mcpHeaderKey: 'Key',
    mcpHeaderValue: 'Value',
    noMcpServersAvailable: 'No MCP servers configured',
    mcpDeleteConfirm: 'Delete MCP server "{name}"?',
    mcpDeleteFailed: 'Failed to delete MCP server',
    mcpCreateFailed: 'Failed to create MCP server',
    mcpUpdateFailed: 'Failed to update MCP server',
    mcpNameRequired: 'Server name is required',
    mcpCommandRequired: 'Command is required for stdio transport',
    mcpUrlRequired: 'URL is required for SSE/HTTP transport',
    mcpNameExists: 'Server name already exists',
    mcpTransportStdio: 'Standard I/O (stdio)',
    mcpTransportSse: 'Server-Sent Events (SSE)',
    mcpTransportHttp: 'Streamable HTTP',
    addKeyValue: 'Add',
    saveMcpServer: 'Save',
    // MCP Marketplace & Registry
    mcpInstalled: 'Installed',
    mcpMarketplace: 'Marketplace',
    mcpCustom: 'Custom',
    mcpCustomDescription: 'Manually configure an MCP server',
    mcpResetForm: 'Reset',
    mcpInstall: 'Install',
    mcpInstallFromUrl: 'Install from URL',
    mcpInstallFromUrlTitle: 'Install MCP from URL',
    mcpInstallFromUrlPlaceholder: 'Enter npm package name or URL',
    mcpInstallFromUrlHint: 'Supports npm package names (e.g. @modelcontextprotocol/server-filesystem), npx commands, or HTTP/HTTPS URLs',
    mcpRequiredConfig: 'Required Configuration',
    mcpOptionalConfig: 'Optional Configuration',
    mcpViewOnGithub: 'View on GitHub',
    mcpNoInstalledServers: 'No MCP servers installed yet',
    mcpCategoryAll: 'All',
    mcpCategorySearch: 'Search',
    mcpCategoryBrowser: 'Browser',
    mcpCategoryDeveloper: 'Dev Tools',
    mcpCategoryProductivity: 'Productivity',
    mcpCategoryDesign: 'Design',
    mcpCategoryDataApi: 'Data & API',
    mcpDesc_tavily: 'Real-time web search, intelligent data extraction and web crawling',
    mcpDesc_github: 'GitHub platform integration: repos, issues, PRs, Actions management',
    mcpDesc_gitlab: 'GitLab API integration: project management, merge requests, pipelines',
    mcpDesc_context7: 'Up-to-date library documentation and code examples for AI coding',
    mcpDesc_google_drive: 'Google Drive file access and search with auto-export for Workspace files',
    mcpDesc_gmail: 'Gmail management: read, send, search emails with auto authentication',
    mcpDesc_google_calendar: 'Google Calendar management: create, query, update calendar events',
    mcpDesc_notion: 'Notion API: search, create/update pages, manage databases',
    mcpDesc_slack: 'Slack workspace: channel management, messaging, user queries',
    mcpDesc_todoist: 'Task management: create, update, complete and organize to-do items',
    mcpDesc_playwright: 'Advanced browser automation supporting Chromium/Firefox/WebKit',
    mcpDesc_canva: 'Canva design platform: create and manage designs, template operations',
    mcpDesc_firecrawl: 'Web scraping and data extraction: batch processing, structured extraction and content analysis',
    mcpDesc_fetch: 'Web content fetching and HTML-to-markdown conversion for LLM consumption',

    // Email Skill Config
    emailTab: 'Email',
    emailConfig: 'Email Configuration',
    emailProvider: 'Email Provider',
    emailSelectProvider: 'Select email provider',
    emailCustomProvider: 'Custom',
    emailAddress: 'Email Address',
    emailPassword: 'Password / Auth Code',
    emailPasswordPlaceholder: 'Password or app-specific password',
    emailAdvancedSettings: 'Advanced Settings',
    emailMailbox: 'Default Mailbox',
    emailConfigSaved: 'Email configuration saved',
    emailConfigError: 'Failed to save configuration',
    emailHintGmail: 'If 2FA is enabled, use an App Password instead of your account password',
    emailHint163: 'Use an authorization code, not your account password. Enable IMAP/SMTP in web settings first',
    emailHintQQ: 'Use an authorization code, not your account password. Enable IMAP/SMTP in web settings first',

    // File operations
    openFile: 'Open File',
    openFolder: 'Open Folder',
    showInFolder: 'Show in Folder',
    outputFiles: 'Output Files',
    openFileFailed: 'Failed to open file',
    fileCreated: 'File created',

    // IM Bot
    imBot: 'IM Bot',
    dingtalk: 'DingTalk',
    feishu: 'Feishu',
    qq: 'QQ',
    telegram: 'Telegram',
    discord: 'Discord',
    nim: 'NetEase IM',
    xiaomifeng: 'Netease Bee',
    wecom: 'WeCom',
    connected: 'Connected',
    disconnected: 'Disconnected',
    kickedByOtherClient: 'Account logged in elsewhere',
    starting: 'Starting',
    start: 'Start',
    stop: 'Stop',
    messageType: 'Message Type',
    domain: 'Domain',
    feishuChina: 'Feishu (China)',
    renderMode: 'Render Mode',
    textMode: 'Text',
    cardMode: 'Card',
    chatSettings: 'Chat Settings',
    enableSkills: 'Enable Skills',
    systemPrompt: 'System Prompt',
    systemPromptPlaceholder: 'Set custom instructions for IM bot...',
    saveConfig: 'Save Config',
    imConnectivitySectionTitle: 'Connectivity Diagnostics',
    imConnectivityTest: 'Test Connectivity',
    imConnectivityRetest: 'Retest',
    imConnectivityTesting: 'Testing...',
    imConnectivityNoResult: 'No diagnostics yet. Test after enabling the gateway.',
    imConnectivityLastChecked: 'Last checked',
    imConnectivitySuggestion: 'Suggestion',
    imConnectivityVerdict_pass: 'Ready',
    imConnectivityVerdict_warn: 'Attention Needed',
    imConnectivityVerdict_fail: 'Unavailable',
    imConnectivityCheckTitle_missing_credentials: 'Missing Credentials',
    imConnectivityCheckTitle_auth_check: 'Credential Authentication',
    imConnectivityCheckTitle_gateway_running: 'IM Channel Enablement',
    imConnectivityCheckTitle_inbound_activity: 'Inbound Message Activity',
    imConnectivityCheckTitle_outbound_activity: 'Outbound Message Activity',
    imConnectivityCheckTitle_platform_last_error: 'Recent Platform Error',
    imConnectivityCheckTitle_feishu_group_requires_mention: 'Feishu Group Trigger Rule',
    imConnectivityCheckTitle_feishu_event_subscription_required: 'Feishu Event Subscription Requirement',
    imConnectivityCheckTitle_discord_group_requires_mention: 'Discord Group Trigger Rule',
    imConnectivityCheckTitle_telegram_privacy_mode_hint: 'Telegram Privacy Mode',
    imConnectivityCheckTitle_dingtalk_bot_membership_hint: 'DingTalk Conversation Permission',
    imConnectivityCheckTitle_nim_p2p_only_hint: 'NetEase IM P2P Mode',
    imConnectivityCheckSuggestion_missing_credentials: 'Fill required credentials and test again.',
    imConnectivityCheckSuggestion_auth_check: 'Verify credentials, permissions, and app release status.',
    imConnectivityCheckSuggestion_gateway_running: 'If disabled, click the IM channel pill to enable it, then verify platform endpoints are reachable.',
    imConnectivityCheckSuggestion_inbound_activity: 'Send a test message to the bot; mention it in group chats.',
    imConnectivityCheckSuggestion_outbound_activity: 'Check bot send permissions and conversation reply scope.',
    imConnectivityCheckSuggestion_platform_last_error: 'Fix the reported error and run diagnostics again.',
    imConnectivityCheckSuggestion_feishu_group_requires_mention: 'Use @bot plus your message in group chats.',
    imConnectivityCheckSuggestion_feishu_event_subscription_required: 'Enable im.message.receive_v1 and publish app version.',
    imConnectivityCheckSuggestion_discord_group_requires_mention: 'Use @bot plus your message in channels.',
    imConnectivityCheckSuggestion_telegram_privacy_mode_hint: 'Review Privacy Mode in @BotFather settings.',
    imConnectivityCheckSuggestion_dingtalk_bot_membership_hint: 'Ensure the bot is in the target conversation with send/receive rights.',
    imConnectivityCheckSuggestion_nim_p2p_only_hint: 'Send messages via direct chat to the bot account.',
    nimAccountPlaceholder: 'Bot account ID',
    nimAccountHint: 'IM account ID (accid) created in NetEase IM console account management',
    nimCredentialsGuide: 'How to obtain NetEase IM credentials:',
    nimGuideStep1: 'Log in to NetEase IM console (yunxin.163.com)',
    nimGuideStep2: 'Create or select an app to get the App Key',
    nimGuideStep3: 'Create an IM account (accid) in "Account Numbers - Sub-feature Configuration"',
    nimGuideStep4: 'Generate a Token (password) for this account - long-term validity recommended',
    nimAppKeyHint: 'Obtain from app information in NetEase IM console',
    nimTokenHint: 'Access credential generated for this account (long-term validity recommended)',
    nimAccountWhitelist: 'Account Whitelist',
    nimAccountWhitelistHint: 'Enter NIM accounts allowed to chat with the bot, separated by commas. Leave empty to allow all accounts.',
    nimTeamPolicy: 'Team Message Policy',
    nimTeamPolicyDisabled: 'Disabled - Do not respond to team messages',
    nimTeamPolicyOpen: 'Open - Respond to @mentions in all teams',
    nimTeamPolicyAllowlist: 'Allowlist - Only respond to @mentions in specified teams',
    nimTeamPolicyHint: 'Bot only responds when @-mentioned in team messages',
    nimTeamAllowlist: 'Team Allowlist',
    nimTeamAllowlistHint: 'Enter team IDs to allow, separated by commas',
    nimQChatEnabled: 'Enable QChat (Circle Groups)',
    nimQChatEnabledHint: 'Subscribe to QChat messages, only responds to @mentions',
    nimQChatServerIds: 'QChat Server IDs',
    nimQChatServerIdsPlaceholder: 'Leave empty to auto-discover all joined servers',
    nimQChatServerIdsHint: 'Specify server IDs to subscribe, separated by commas. Leave empty to auto-subscribe all joined servers.',
    xiaomifengClientIdPlaceholder: 'Netease Bee IM Client ID',

    // General Settings
    autoLaunch: 'Launch at Login',
    autoLaunchDescription: 'Automatically start the app when you log in',
    useSystemProxy: 'Use System Proxy',
    useSystemProxyDescription: 'When enabled, network requests follow system proxy settings (applies after Save)',

    // Scheduled Tasks
    scheduledTasks: 'Scheduled Tasks',
    scheduledTasksTitle: 'Scheduled Tasks',
    scheduledTasksNewTask: 'New Task',
    scheduledTasksEmptyState: 'No scheduled tasks',
    scheduledTasksEmptyHint: 'Create scheduled tasks to automate AI execution on a schedule',
    scheduledTasksListColTitle: 'Title',
    scheduledTasksListColSchedule: 'Scheduled For',
    scheduledTasksListColStatus: 'Status',
    scheduledTasksListColMore: 'More',
    scheduledTasksTabTasks: 'Tasks',
    scheduledTasksTabHistory: 'History',
    scheduledTasksHistoryEmpty: 'No run history',

    // Task Manager
    taskManager: 'Log Assistant',
    taskManagerTitle: 'Manage Tasks',
    taskManagerNewTask: 'New Task',
    taskManagerEmptyState: 'No tasks',
    taskManagerEmptyHint: 'Create tasks or extract them from chat',
    taskManagerListColTitle: 'Title',
    calendar: 'Calendar',
    list: 'List',
    chat: 'Chat',
    scheduledTasksHistoryColTitle: 'Title',
    scheduledTasksHistoryColTime: 'Run Time',
    scheduledTasksHistoryColStatus: 'Status',
    scheduledTasksFormName: 'Title',
    scheduledTasksFormNamePlaceholder: 'Enter task title',
    scheduledTasksFormDescription: 'Description',
    scheduledTasksFormDescriptionPlaceholder: 'Optional task description',
    scheduledTasksFormScheduleType: 'Plan',
    scheduledTasksFormScheduleModeOnce: 'Once',
    scheduledTasksFormScheduleModeDaily: 'Daily',
    scheduledTasksFormScheduleModeWeekly: 'Weekly',
    scheduledTasksFormScheduleModeMonthly: 'Monthly',
    scheduledTasksFormWeekSun: 'Sunday',
    scheduledTasksFormWeekMon: 'Monday',
    scheduledTasksFormWeekTue: 'Tuesday',
    scheduledTasksFormWeekWed: 'Wednesday',
    scheduledTasksFormWeekThu: 'Thursday',
    scheduledTasksFormWeekFri: 'Friday',
    scheduledTasksFormWeekSat: 'Saturday',
    scheduledTasksFormValidationTimeRequired: 'Please select a time',
    scheduledTasksFormValidationWorkingDirectoryRequired: 'Task working directory is required',
    scheduledTasksFormMonthDaySuffix: '',
    scheduledTasksFormScheduleAt: 'One-time',
    scheduledTasksFormScheduleAtHint: 'Run once at a specified time',
    scheduledTasksFormScheduleInterval: 'Interval',
    scheduledTasksFormScheduleIntervalHint: 'Repeat at fixed intervals',
    scheduledTasksFormScheduleCron: 'Cron Expression',
    scheduledTasksFormScheduleCronHint: 'Define complex schedules with Cron',
    scheduledTasksFormDatetime: 'Execution Time',
    scheduledTasksFormInterval: 'Interval',
    scheduledTasksFormIntervalMinutes: 'minutes',
    scheduledTasksFormIntervalHours: 'hours',
    scheduledTasksFormIntervalDays: 'days',
    scheduledTasksFormCronExpression: 'Cron Expression',
    scheduledTasksFormCronPlaceholder: 'e.g. */5 * * * * (every 5 minutes)',
    scheduledTasksFormCronHelp: 'Format: min hour day month weekday (5 fields)',
    scheduledTasksFormPrompt: 'Execution Prompt',
    scheduledTasksFormPromptPlaceholder: 'Enter the prompt to execute...',
    scheduledTasksFormWorkingDirectory: 'Working Directory',
    scheduledTasksFormWorkingDirectoryPlaceholder: 'Enter project path',
    scheduledTasksFormSystemPrompt: 'System Prompt',
    scheduledTasksFormSystemPromptPlaceholder: 'Optional system prompt...',
    scheduledTasksFormExecutionMode: 'Execution Mode',
    scheduledTasksFormExecutionModeAuto: 'Auto',
    scheduledTasksFormExecutionModeLocal: 'Local',
    scheduledTasksFormExecutionModeSandbox: 'Sandbox',
    scheduledTasksFormEnabled: 'Enable Task',
    scheduledTasksFormCreate: 'Create Task',
    scheduledTasksFormUpdate: 'Update Task',
    scheduledTasksFormValidationNameRequired: 'Task title is required',
    scheduledTasksFormValidationPromptRequired: 'Execution prompt is required',
    scheduledTasksFormValidationDatetimeFuture: 'Execution time must be in the future',
    scheduledTasksFormValidationIntervalPositive: 'Interval must be greater than 0',
    scheduledTasksFormValidationCronRequired: 'Cron expression is required',
    scheduledTasksEdit: 'Edit',
    scheduledTasksDelete: 'Delete',
    scheduledTasksDeleteConfirm: 'Are you sure you want to delete task "{name}"? This cannot be undone.',
    scheduledTasksRun: 'Run Now',
    scheduledTasksStop: 'Stop',
    scheduledTasksEnabled: 'Enabled',
    scheduledTasksDisabled: 'Disabled',
    scheduledTasksDetail: 'Task Detail',
    scheduledTasksConfiguration: 'Configuration',
    scheduledTasksSchedule: 'Plan',
    scheduledTasksPrompt: 'Prompt',
    scheduledTasksWorkingDirectory: 'Working Directory',
    scheduledTasksSystemPrompt: 'System Prompt',
    scheduledTasksExecutionMode: 'Execution Mode',
    scheduledTasksStatus: 'Status',
    scheduledTasksNextRun: 'Next Run',
    scheduledTasksLastRun: 'Last Run',
    scheduledTasksLastDuration: 'Last Duration',
    scheduledTasksLastError: 'Last Error',
    scheduledTasksConsecutiveErrors: 'Consecutive Errors',
    scheduledTasksRunHistory: 'Run History',
    scheduledTasksNoRuns: 'No runs yet',
    scheduledTasksLoadMore: 'Load More',
    scheduledTasksManual: 'Manual',
    scheduledTasksScheduled: 'Scheduled',
    scheduledTasksViewSession: 'View Session',
    scheduledTasksStatusSuccess: 'Success',
    scheduledTasksStatusError: 'Failed',
    scheduledTasksStatusRunning: 'Running',
    scheduledTasksStatusIdle: 'Idle',
    scheduledTasksNotSet: 'Not set',
    scheduledTasksNone: 'None',
    scheduledTasksScheduleAtLabel: 'One-time',
    scheduledTasksScheduleIntervalLabel: 'Interval',
    scheduledTasksScheduleCronLabel: 'Cron',
    scheduledTasksScheduleEvery: 'Every',
    scheduledTasksAutoDisabledErrors: 'Task auto-disabled due to too many consecutive errors',
    scheduledTasksCreateFailed: 'Failed to create task',
    scheduledTasksUpdateFailed: 'Failed to update task',
    scheduledTasksDeleteFailed: 'Failed to delete task',
    scheduledTasksRunFailed: 'Failed to run task',
    scheduledTasksStopFailed: 'Failed to stop task',
    scheduledTasksFormExpiresAt: 'Expiration Date',
    scheduledTasksFormOptional: '(Optional)',
    scheduledTasksFormExpiresAtHint: 'Optional. Task will stop running after this date',
    scheduledTasksFormExpiresAtClear: 'Clear',
    scheduledTasksFormExpiresAtNone: 'Never expires',
    scheduledTasksDetailExpiresAt: 'Expiration Date',
    scheduledTasksFormNotify: 'IM Notification',
    scheduledTasksFormNotifyHint: 'Optional. Send task results via IM after completion',
    scheduledTasksFormNotifyDingtalk: 'DingTalk',
    scheduledTasksFormNotifyFeishu: 'Feishu',
    scheduledTasksFormNotifyQq: 'QQ',
    scheduledTasksFormNotifyTelegram: 'Telegram',
    scheduledTasksFormNotifyDiscord: 'Discord',
    scheduledTasksFormNotifyNim: 'NetEase IM',
    scheduledTasksFormNotifyXiaomifeng: 'Xiaomifeng',
    scheduledTasksFormNotifyWecom: 'WeCom',
    scheduledTasksFormNotifyNone: 'None',
    scheduledTasksFormNotifyNotConfigured: 'Not configured',
    scheduledTasksDetailNotify: 'Notification',
    scheduledTasksToggleWarningAtPast: 'The execution time of this task has passed. It will not run after enabling',
    scheduledTasksToggleWarningExpired: 'This task has expired. It will not run after enabling',
  }
};

class I18nService {
  private currentLanguage: LanguageType = 'zh';
  private listeners = new Set<() => void>();
  
  constructor() {
    // 默认使用中文
    this.currentLanguage = 'zh';
  }
  
  // 初始化语言设置
  async initialize(): Promise<void> {
    try {
      const config = configService.getConfig();

      // 检查是否已经初始化过语言设置
      const languageInitialized = config.language_initialized;

      if (languageInitialized !== true) {
        // 可能是首次启动或旧版本用户升级
        // 为了保护旧用户的语言设置,检查是否有非默认的语言配置
        const hasCustomLanguage = config.language && config.language !== 'zh';

        if (hasCustomLanguage) {
          // 旧用户已手动设置过语言(非默认值),保留他们的设置
          console.log(`[i18n] Legacy user detected with custom language: ${config.language}`);
          this.currentLanguage = config.language;
          configService.updateConfig({
            ...config,
            language_initialized: true
          });
        } else {
          // New users: detect browser language
          try {
            const browserLang = navigator.language || 'en';
            const detectedLanguage = this.inferLanguageFromLocale(browserLang);
            console.log(`[i18n] First run detected. Browser language: ${browserLang}, default language: ${detectedLanguage}`);

            this.currentLanguage = detectedLanguage;

            configService.updateConfig({
              ...config,
              language: detectedLanguage,
              language_initialized: true
            });
          } catch (error) {
            console.error('Failed to get system locale:', error);
            // 如果获取系统语言失败,默认使用英文
            this.currentLanguage = 'en';
            configService.updateConfig({
              ...config,
              language: 'en',
              language_initialized: true
            });
          }
        }
      } else {
        // 非首次启动:使用已保存的语言配置
        if (config.language && (config.language === 'zh' || config.language === 'zh-TW' || config.language === 'en')) {
          this.currentLanguage = config.language;
        } else {
          // 如果配置无效,fallback 到英文
          this.currentLanguage = 'en';
          configService.updateConfig({
            ...config,
            language: 'en'
          });
        }
      }
    } catch (error) {
      console.error('Failed to initialize language:', error);
      // 默认使用英文
      this.currentLanguage = 'en';
    }
  }

  // 根据系统语言推断应用语言
  private inferLanguageFromLocale(systemLocale: string): LanguageType {
    // zh-CN 和 zh-SG 使用简体中文
    if (systemLocale === 'zh-CN' || systemLocale === 'zh-SG' || systemLocale === 'zh-Hans') {
      return 'zh';
    }
    // zh-TW、zh-HK、zh-Mo 使用繁體中文
    if (systemLocale === 'zh-TW' || systemLocale === 'zh-HK' || systemLocale === 'zh-MO' || systemLocale === 'zh-Hant') {
      return 'zh-TW';
    }
    // 以 zh- 開頭但未明確匹配的也使用繁體（如 zh-TW 的 fallback）
    if (systemLocale.startsWith('zh-')) {
      return 'zh-TW';
    }
    return 'en'; // 默認英文
  }
  
  // 设置语言
  setLanguage(language: LanguageType, options: { persist?: boolean } = {}): void {
    const { persist = true } = options;
    const hasChanged = this.currentLanguage !== language;
    this.currentLanguage = language;

    if (hasChanged) {
      this.listeners.forEach((listener) => listener());
    }

    if (!persist) {
      return;
    }

    // 更新配置
    try {
      const config = configService.getConfig();
      configService.updateConfig({
        ...config,
        language
      });
    } catch (error) {
      console.error('Failed to save language setting:', error);
    }
  }
  
  // 获取当前语言
  getLanguage(): LanguageType {
    return this.currentLanguage;
  }
  
  // 获取翻译文本
  t(key: string): string {
    const translation = translations[this.currentLanguage][key];
    let result: string | undefined;
    if (!translation) {
      console.warn(`Translation missing for key: ${key} in language: ${this.currentLanguage}`);
      const fallbackOrder: LanguageType[] = this.currentLanguage === 'en' ? ['zh', 'zh-TW'] : this.currentLanguage === 'zh-TW' ? ['zh', 'en'] : ['en', 'zh-TW'];
      for (const fallbackLang of fallbackOrder) {
        const fallbackTranslation = translations[fallbackLang][key];
        if (fallbackTranslation) { result = fallbackTranslation; break; }
      }
    } else {
      result = translation;
    }
    const finalResult = result || key;
    if (finalResult.includes('{appName}')) {
      return finalResult.replace(/\{appName\}/g, brandService.getName());
    }
    return finalResult;
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const i18nService = new I18nService(); 
